const translations = {
  en: {
    brand: { name: 'Ayyappankadu Ayyappa Temple', tag: 'Faith • Heritage • Renewal' },
    nav: { home: 'Home', about: 'About', renovation: 'Renovation', gallery: 'Gallery', festivals: 'Festivals', contact: 'Contact' },
    hero: {
      slides: [
        { eyebrow: 'Swamiye Saranam Ayyappa', title: 'Ayyappankadu Ayyappa Temple', text: 'An ancient abode of Lord Ayyappa, rising again through the devotion of the faithful.' },
        { eyebrow: 'Temple Renovation', title: 'Help Us Restore a Centuries-Old Temple', text: 'Devotees are united to rebuild the sacred shrine of Ayyappankadu. Join this noble cause.' },
        { eyebrow: 'Light of Devotion', title: 'Where Every Lamp Carries a Prayer', text: 'Daily poojas, festive vilakku and the peace of a Kerala village shrine.' },
      ],
      cta1: 'Support Renovation', cta2: 'Explore the Temple',
    },
    about: {
      eyebrow: 'About the Temple', title: 'A Timeless Abode of Dharma Sastha',
      p1: 'The Ayyappankadu Ayyappa Temple has stood for centuries as a place of faith for the people of the village. Its sacred grounds, once flourishing with daily worship, now await the loving hands of devotees.',
      p2: 'A group of devotees, led by a group of women, has begun the work of restoring the temple, guided by tradition and the Deva Prashnam.',
      deity: 'Presiding Deity', deityV: 'Lord Dharma Sastha (Ayyappa)', location: 'Location', locationV: 'Ayyappankadu, Kerala, India', est: 'Established', estV: 'Centuries old', more: 'Know More About the Temple',
      historyTitle: 'Our Story', history: 'Known by the name Ayyappankadu, the temple was cared for by generations. Local residents recall 40 cents of land set aside for the shrine in earlier times, always regarded as temple property. Today, it is found in a ruined condition, and the community has risen to bring it back to life.',
    },
    abx: {
      journeyEyebrow: 'Our Journey So Far',
      journeyTitle: 'Moments That Revived the Shrine',
      journeySub: 'From the first bhajans in the forest to the foundation stone of the new shrine.',
      journey: [
        'The mothers who first chanted bhajans on mats spread in the forest',
        'Elephants visit the temple on the day of Deva Prashnam',
        'Worship after the purification of the idol',
        'Alankaram: ornamentation of the idol',
        'Payasam prepared in the temple courtyard for the first time',
        'Kalavara Nirakkal',
        'Ornamentation before Ganapathi Homam (Bhagavathy Seva)',
        'Ganapathi Homam',
        'Pooja by the Amma of Nalakath Illam',
        'Narayaneeyam Parayanam',
        'Malakettal: garlands for the Lord',
        'The first Saptaham',
        'Visit of the present landowner',
        'Deva Prashnam: divine consultation',
        'Bhoomi Pooja',
        'Sri Satheesh Menon performs the Kuttiyadikkal (foundation stake-laying) ceremony',
        'Monthly devotional singing (bhajan) by housewives',
        'The mothers\' prayer to raise a temple',
        'Saptaham: Lord Krishna and Rukmini',
        'Rukmini being brought in procession',
      ],

      deityEyebrow: 'The Sacred Form',
      deityTitle: 'The Idol of Ayyappankadu',
      deitySub: 'Every feature of the idol carries a meaning.',
      tableHead: ['Part', 'Feature', 'Possible meaning'],
      form: [
        { p: 'Head', f: 'Matted locks spread like a peacock feather', m: 'Tapas, yogic power' },
        { p: 'Crown', f: 'Ornament spreading to both sides', m: 'A distinct form of the jatamakuta' },
        { p: 'Behind the head', f: 'Circular halo', m: 'Divinity, radiance' },
        { p: 'Eyes', f: 'Half-open', m: 'Meditation and alertness' },
        { p: 'Seat', f: 'Padmasana', m: 'Yoga and self-control' },
        { p: 'Left hand', f: 'Resting on the thigh', m: 'Meditative mood' },
        { p: 'Right hand', f: 'Holds an object between the index and middle fingers', m: 'A weapon or ritual implement' },
        { p: 'Belly', f: 'Ribbon-like band across', m: 'Udarabandha' },
        { p: 'Neck', f: 'Garlands and rudraksha', m: 'Austerity, spirituality' },
      ],
      chipsTitle: 'Symbols of the Yogi-Lord',
      chips: [
        ['Padmasana', 'Self-control'],
        ['Jatamakuta', 'Power of tapas'],
        ['Rudraksha', 'Detachment'],
        ['Pasha', 'Power to bind'],
        ['Ankusha', 'Power to guide'],
        ['Prabhamandalam', 'Divinity'],
      ],
      tattvaEyebrow: 'The Guiding Idea',
      mantra: 'Pāśena badhnāti, aṅkuśena nayati',
      mantraMeaning: 'The pasha draws us back from adharma; the ankusha leads us onto the path of dharma. Dharma Sastha is the meditating yogi, the upholder of justice and the guardian of the forest.',
      roles: [
        { t: 'Pasha', pts: ['Brings us back from the bondage of adharma', 'Restrains wrong actions', 'Gives discipline and justice'] },
        { t: 'Ankusha', pts: ['Leads onto the path of dharma', 'Guides the mind and senses', 'Gives a sense of direction'] },
      ],
      shaktiEyebrow: 'Divine Powers',
      shaktiTitle: 'The Twelve Shaktis of Dharma Sastha',
      shaktiSub: 'Not miracles alone, but powers that lead us to dharma, protect nature and lift the spirit.',
      shaktis: [
        { t: 'Jnana Shakti', d: 'Removes ignorance and gives wisdom and sound judgement. Blesses as guru and teacher.' },
        { t: 'Pasha Shakti', d: 'Binds those who stray back to dharma and gives self-control to leave bad tendencies.' },
        { t: 'Ankusha Shakti', d: 'Restrains the wandering mind and senses and guides them in the right direction.' },
        { t: 'Abhaya Shakti', d: 'Gives courage and confidence to overcome fear, insecurity and despair.' },
        { t: 'Veera Shakti', d: 'Gives strength of heart to stand against injustice and protect the weak.' },
        { t: 'Yoga Shakti', d: 'Brings balance of mind, body and senses, and the power to meditate.' },
        { t: 'Anugraha Shakti', d: 'Gives hope and confidence in hard times and inspires good deeds.' },
        { t: 'Prakriti Raksha Shakti', d: 'Nurtures care for forests, animals, birds, waters and nature.' },
        { t: 'Nyaya Shakti', d: 'Grows a sense of justice, honesty, responsibility and righteous governance.' },
        { t: 'Tapas Shakti', d: 'Increases self-control, patience, endurance and willpower.' },
        { t: 'Raksha Shakti', d: 'Inspires love, safety and cooperation in family and community.' },
        { t: 'Moksha Shakti', d: 'Frees us from ego, craving and ignorance and leads to spiritual elevation.' },
      ],
      note: 'Interpretations of the idol and its symbols follow devotional tradition and may vary among scholars and temple traditions.',
    },
    quick: ['Temple History', 'Poojas & Rituals', 'Festival Details', 'Gallery', 'How to Reach'],
    highlights: {
      title: 'Temple Highlights', sub: 'Experience the divine beauty and spiritual essence of Ayyappankadu.',
      items: [
        { t: 'Sacred Heritage', d: 'Centuries of worship and local tradition.' },
        { t: 'Lord Ayyappa', d: 'Blessings of Dharma Sastha for all devotees.' },
        { t: 'Daily Poojas', d: 'Regular rituals and offerings.' },
        { t: 'Festivals', d: 'Vilakku, Mandala Pooja and more.' },
        { t: 'Peaceful Surroundings', d: 'Serene Kerala village atmosphere.' },
        { t: 'Community Seva', d: 'Led by devotees, supported by all.' },
      ],
    },
    deities: {
      title: 'Deities of the Temple',
      sub: 'The presiding and accompanying deities who bless every devotee at Ayyappankadu.',
      items: [
        { tag: 'Main Deity', name: 'Lord Ayyappa', d: 'Lord Dharma Sastha, the meditating yogi, upholder of dharma and guardian of the forest.' },
        { tag: 'Deity 1', name: 'Devi', d: 'The Divine Mother, enshrined beside the main sanctum, who showers compassion on all devotees.' },
        { tag: 'Deity 2', name: 'Lord Ganapathy', d: 'The remover of obstacles, invoked at the beginning of every pooja and auspicious work.' },
      ],
    },
    silas: {
      eyebrow: 'Ceremony',
      title: 'Silasthapanam',
      subtitle: 'Foundation Stone Laying Ceremony',
      temple: 'Ayyappankadu Ayyappa Temple, Pudussery, Palakkad',
      dateL: 'Date', date: 'Thursday, 5 November 2026',
      timeL: 'Time', time: 'Between 7:10 AM and 9:20 AM',
      guestsT: 'In the Presence of',
      guests: [
        { n: 'Swami Udit Chaitanya', r: 'Bhagavathgramam' },
        { n: 'Swami Swarupananda Saraswathi', r: 'Shivanandashramam, Palakkad' },
        { n: 'Dr. Shyam Prasad', r: 'Melshanti, Anicode Anbumurthi Temple' },
      ],
      orgL: 'Organised by', org: 'Sandeepani Sadhanalaya Charitable & Welfare Trust',
      phone: '9847960323',
      invite: 'All devotees are warmly invited to take part and receive the blessings.',
      cdT: 'Time to the ceremony', dLabel: 'Days', hLabel: 'Hours', mLabel: 'Mins',
      done: 'The auspicious hour has arrived. Swamiye Saranam Ayyappa!',
      cta2: 'Support Renovation',
      jrTitle: 'Steps Toward the New Shrine',
      jrSub: 'Recent moments from the restoration journey.',
      jrAll: 'See the full journey',
    },
    gallery: {
      title: 'Temple Gallery', sub: 'Capturing the divine moments of our temple.', all: 'View Full Gallery',
      eyebrow: 'Sacred Moments', photos: 'Photographs', hint: 'Tap any photo to view it in full',
      mosaic: 'Mosaic', grid: 'Grid', view: 'View photo', close: 'Close', prev: 'Previous', next: 'Next',
      loadMore: 'Load more photos',
      introEyebrow: 'Our Gallery', introTitle: 'Glimpses of a Sacred Abode',
      introText: 'Browse photographs and videos from Ayyappankadu: daily poojas, festival lamps, the quiet village shrine and the devotion of the community working to restore it.',
      videos: 'Videos', heritage: 'Of heritage', centuries: 'Centuries',
      momentsEyebrow: 'What You Will See', momentsTitle: 'Moments We Treasure',
      moments: [
        { t: 'Daily Poojas', d: 'Morning and evening prayers that keep the shrine alive.' },
        { t: 'Festival Lamps', d: 'Rows of vilakku glowing across the temple grounds.' },
        { t: 'Village Shrine', d: 'The quiet beauty of a Kerala village temple.' },
        { t: 'Renovation Seva', d: 'Devotees coming together to rebuild the shrine.' },
      ],
      videosEyebrow: 'Watch', videosTitle: 'Temple Videos', videosSub: 'Tap a video to watch it in full screen.',
      videoTitles: ['Temple Darshan', 'Festival Vilakku', 'Renovation Seva', 'Village Shrine'],
      play: 'Play video',
      ctaTitle: 'Be a Part of Our Story', ctaText: 'Visit the temple, join the festivals and help bring the shrine back to life.',
      ctaBtn1: 'Support Renovation', ctaBtn2: 'Contact the Samithi',
    },
    festivals: {
      title: 'Festivals & Events', sub: 'Join us in celebrating the divine.', all: 'View All Festivals', learn: 'Learn More',
      items: [
        { m: 'Jan – Feb', t: 'Makara Vilakku', d: 'Special darshan, lamps and cultural programs.' },
        { m: 'Nov – Dec', t: 'Mandala Pooja', d: 'Forty-one days of vratham and grand pooja.' },
        { m: 'Karthika', t: 'Karthika Vilakku', d: 'Lighting of lamps across the temple grounds.' },
        { m: 'Dec – Jan', t: 'Sabarimala Yatra', d: 'Devotees begin their pilgrimage with irumudi.' },
      ],
    },
    festPage: {
      vzEyebrow: 'Special Vazhipad',
      vzTitle: 'Special Vazhipad (Offerings)',
      vzSub: 'Devotees may offer these special vazhipads at the temple.',
      vzItems: [
        {
          t: 'Neyvilakku', ml: 'നെയ്‌വിളക്ക്', tag: 'Offering',
          d: 'A lamp lit with pure ghee before the Lord as an offering of light, devotion and prayer.',
        },
        {
          t: 'Ezhuthiri Kathikkal', ml: 'എഴുതിരി കത്തിക്കൽ', tag: 'Every Saturday',
          d: 'The lighting of the multi-wick lamp before the deity, offered every Saturday.',
        },
        {
          t: 'Neeranjanam', ml: 'നീരാഞ്ജനം', tag: 'Pooja',
          d: 'A traditional lamp offering to the Lord, performed with prayer for the removal of obstacles and the blessings of Lord Ayyappa.',
        },
      ],
      vzNote: 'Please contact the Samithi to book these vazhipads and confirm the timings.',
      eyebrow: 'Sacred Observances',
      intro: 'Throughout the year the temple comes alive with lamps, vratham and prayer. Each festival is a chance for devotees to gather, give and receive the blessings of Lord Dharma Sastha.',
      stats: [
        { v: '4', l: 'Major observances' },
        { v: '41', l: 'Days of Mandala vratham' },
        { v: 'Nov – Feb', l: 'Peak festival season' },
        { v: 'All', l: 'Devotees welcome' },
      ],
      detailsEyebrow: 'Festival Details',
      detailsTitle: 'Observances at Ayyappankadu',
      highlightsT: 'Customary observances',
      items: [
        {
          long: 'Makara Vilakku is celebrated around Makara Sankranti, when devotees gather to mark the auspicious turn of the season. The shrine is lit with rows of lamps and special darshan is offered, along with cultural programs for the community.',
          points: ['Special darshan', 'Lighting of lamps at dusk', 'Cultural programs for all ages'],
        },
        {
          long: 'Mandala Pooja marks forty-one days of strict vratham. Devotees take up simple living, wear the sacred mala and visit the temple for daily prayer, culminating in a grand pooja at the end of the Mandala period.',
          points: ['Forty-one days of vratham', 'Daily prayer and bhajans', 'Grand pooja on the final day'],
        },
        {
          long: 'During Karthika Vilakku, lamps are lit across the temple grounds as an offering of light. Families and neighbours come together, and the whole compound glows with devotion.',
          points: ['Lamps across the temple grounds', 'Evening prayers', 'Whole village participation'],
        },
        {
          long: 'Sabarimala Yatra begins with irumudi, the sacred bundle carried by pilgrims. Devotees prepare with prayer and vratham before setting out together on the pilgrimage, with the blessings of Lord Ayyappa.',
          points: ['Irumudi preparation', 'Prayers before departure', 'Pilgrims set out together'],
        },
      ],
      calEyebrow: 'Plan Ahead',
      calTitle: 'Festival Season at a Glance',
      calSub: 'Highlighted months show when each festival is observed.',
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      guideEyebrow: 'For Devotees',
      guideTitle: 'Observing the Festivals',
      guide: [
        { t: 'Vratham', d: 'Keep a simple, disciplined routine with prayer and a pure mind during the observance.' },
        { t: 'Attire', d: 'Wear traditional, modest clothing when visiting the temple.' },
        { t: 'Offerings', d: 'Bring flowers, oil for the lamps or any offering made with devotion.' },
        { t: 'Together', d: 'Join the community, help with seva and keep the temple premises clean and peaceful.' },
      ],
      note: 'Dates follow the traditional temple calendar and may vary each year. Please contact the Samithi for confirmed dates.',
      ctaTitle: 'Celebrate With Us',
      ctaText: 'Join the festivals, offer your seva and help bring the shrine back to life.',
      ctaBtn1: 'Contact the Samithi',
      ctaBtn2: 'Support Renovation',
    },
    visit: {
      title: 'Plan Your Visit', sub: 'Your journey to divine blessings begins here.', timingsT: 'Temple Timings', timings: 'Please contact the committee for current timings', locT: 'Location', loc: 'Ayyappankadu, Kerala, India', guideT: 'Visitor Guidance', guide: 'Traditional attire • Maintain temple discipline', directions: 'Get Directions',
    },
    reno: {
      title: 'Temple Renovation', sub: 'A sincere appeal to all devotees', greeting: 'Dear Devotees,',
      paras: [
        'The Ayyappankadu Ayyappa Temple, which has been known by the name Ayyappankadu and existed for centuries, is now found in a completely ruined condition. This is a matter of great sorrow for Ayyappa devotees.',
        'Efforts have been initiated by a group of devotees, under the leadership of a group of women, to renovate and restore the temple. According to information received from local residents, 40 cents of land had been set aside for the temple in earlier times. Although the former claimants are no longer alive, the local people are aware that this land was historically maintained as temple property.',
        'Before commencing the reconstruction of the temple, the Deva Prashnam (traditional astrological consultation) recommended that matters relating to the land be resolved. Accordingly, the devotees are taking the necessary steps to address these matters.',
        'The land currently identified as temple property is being protected. Anyone who has a genuine claim to the land is requested to come forward with the relevant supporting documents.',
        'We sincerely hope that all matters can be resolved through mutual understanding, cooperation, and friendly discussions. We respectfully request everyone to cooperate in resolving these issues amicably.',
        'We humbly appeal to nearby residents, local people, and all devotees to consider this notice as a sincere request for cooperation and to extend their support towards the temple renovation activities.',
      ],
      saranam: 'Swamiye Saranam Ayyappa!!', org: 'Ayyappankadu Ayyappa Seva Samithi', behalf: 'On behalf of the members',
      stepsTitle: 'Our Path Forward',
      steps: ['Deva Prashnam guidance', 'Protecting temple land', 'Resolving claims amicably', 'Reconstruction of the shrine'],
      cta: 'Contact the Samithi',
    },
    renoPage: {
      eyebrow: 'A Sincere Appeal',
      facts: [
        { v: 'Centuries', l: 'Of temple heritage' },
        { v: '40 cents', l: 'Land set aside for the shrine' },
        { v: 'Deva Prashnam', l: 'Guides every step' },
        { v: 'Women-led', l: 'Devotee group at the helm' },
      ],
      noticeTag: 'Important Notice',
      lampEyebrow: 'Offer a Prayer',
      lampTitle: 'Light a Lamp for the Temple',
      lampSub: 'Tap a lamp to light it with your prayer. Every flame is a wish for the shrine to rise again.',
      lampsLit: 'lamps lit',
      lampAll: 'Light all lamps',
      lampReset: 'Start again',
      lampBless: 'Swamiye Saranam! May your prayer be heard.',
      ctaTitle: 'Be Part of the Restoration',
      ctaText: 'Come forward with your prayers, your presence and your support.',
      ctaBtn2: 'Learn about the temple',
      structEyebrow: 'The New Shrine',
      structTitle: 'The Temple Structure',
      structSub: 'This is how the restored shrine will look once construction is complete, in the traditional Kerala style.',
      renderTag: 'After Construction',
      renderCap: 'Artist’s impression of the completed shrines',
      blueprintTag: 'Original Plan',
      blueprintCap: 'Hand-drawn blueprint prepared for the construction',
      zoomHint: 'Tap an image to enlarge',
      closeLabel: 'Close',
      structFeaturesT: 'Highlights of the Design',
      structFeatures: [
        { t: 'Twin Shrines', d: 'Two sreekovils side by side: one for Lord Dharma Sastha and one for Devi.' },
        { t: 'Tiled Roof', d: 'A four-sided sloping roof of red clay tiles with graceful upturned corners.' },
        { t: 'Wooden Pillars', d: 'Turned and polished timber pillars with carved wooden walls and eaves.' },
        { t: 'Golden Kalasam', d: 'A golden finial crowns each roof, the sacred mark of a Kerala shrine.' },
        { t: 'Granite Base', d: 'A stepped granite base (adhishthanam) raises each shrine above the ground.' },
        { t: 'Open Courtyard', d: 'A sandy courtyard shaded by coconut palms and greenery for a peaceful setting.' },
      ],
      structNote: 'The images are for reference. The final construction may vary slightly as guided by the Deva Prashnam and the temple tantri.',
    },
    jyothi: {
      eyebrow: 'Faith of the Elders',
      title: 'Makara Jyothi Darshan at Ayyappankadu',
      sub: 'A belief and tradition handed down by the elders of the village.',
      tag: 'Makara Jyothi',
      intro: 'The elders recall that the Makara Jyothi darshan was once a part of life at Ayyappankadu too.',
      beats: [
        {
          tag: 'The Belief',
          t: 'Uthram, the Lord’s birth star',
          d: 'The Uthram star of the month of Makaram is believed to be the birth star of Lord Ayyappa. On this holy day, the sages of the Sabarimala ashrams and the tribal communities worshipped the Lord with camphor aarti and chants of Saranam, and devotees bowed to that light from afar. We know that this custom continues even today.',
        },
        {
          tag: 'The Sight',
          t: 'The light from Ayyappanmala',
          d: 'On Makara Vilakku day, the devotees of Ayyappankadu would behold the glow of the camphor aarti lit at the forest shrine known as Ayyappanmala in Palakkad. They saw that divine light with devotion, called out Saranam and bowed to the Lord, say the elders.',
        },
        {
          tag: 'The Hope',
          t: 'To be revived after the rebuilding',
          d: 'Once the reconstruction of the Ayyappankadu temple is complete, it is the wish of the devotees to revive this sacred Jyothi darshan and make it a grand spiritual celebration.',
        },
      ],
      quote: 'In the darkness of adharma in Kali Yuga, may the Ayyappa Jyothi lead people into the light of hope and dharma, and bring the light of devotion and goodness to every heart.',
      saranam: 'Swamiye Saranam Ayyappa!',
    },

    committee: {
      eyebrow: 'Our Office Bearers',
      head: ['No.', 'Position', 'Name'],
      title: 'The Temple Committee',
      sub: 'Devotees who lead the restoration with faith and dedication.',
      groups: [
        { role: 'President', names: ['Prof. Shobha Rani'] },
        { role: 'Vice President', names: ['Prasanna Vasudevan'] },
        { role: 'Secretaries', names: ['Sreemathy Radha Ramanunni', 'Premakumari', 'Maheshwari Mani'] },
        { role: 'Treasurer', names: ['Saritha Ramdas'] },
        { role: 'Joint Treasurer', names: ['Bhamini Murali'] },
      ],
    },

    contact: { title: 'Contact Us', sub: 'Reach the Ayyappankadu Ayyappa Seva Samithi', name: 'Your Name', email: 'Email', msg: 'Your Message', send: 'Send Message', address: 'Ayyappankadu, Kerala, India', thanks: 'Thank you! Swamiye Saranam.' },
    quote: 'Devotion in darshan… peace in the heart…',
    home: {
      waysEyebrow: 'Be a Part of It',
      waysTitle: 'Ways to Support the Temple',
      waysSub: 'Every small offering brings the shrine closer to being whole again.',
      ways: [
        { t: 'Support Renovation', d: 'Contribute towards rebuilding the sacred shrine.' },
        { t: 'Volunteer Seva', d: 'Offer your time and skills to the Samithi.' },
        { t: 'Join Festivals', d: 'Celebrate Vilakku and Mandala Pooja with us.' },
        { t: 'Visit the Temple', d: 'Come for darshan and experience the peace.' },
      ],
      go: 'Know more',
      pathEyebrow: 'Renovation Journey',
      ctaTitle: 'Join Us in Restoring a Sacred Abode',
      ctaText: 'Your prayers, presence and support light the way for generations to come.',
      ctaBtn1: 'Support Renovation',
      ctaBtn2: 'Contact the Samithi',
    },
    footer: {
      quote1: 'Devotion in darshan...',
      quote2: 'peace in the heart...',
      about: 'A sacred abode of Lord Dharma Sastha, where devotion, tradition and peace unite for a better tomorrow.',
      links: 'Quick Links',
      info: 'Temple Information',
      contact: 'Contact',
      follow: 'Follow Us',
      stay1: 'Stay Connected',
      stay2: 'with Our Temple',
      stayText: 'Get the latest updates on festivals, renovation and temple activities.',
      subscribe: 'Subscribe for Updates',
      rights: 'All rights reserved.',
      devBy: 'Developed by',
      dev: 'Developed by Mpeoples',
      om: 'Swamiye Saranam Ayyappa',
      addr1: 'Ayyappankadu Ayyappan Kshetram,',
      addr2: 'Pudussery, Palakkad.',
      addr3: '678623',

    },

  },

  ml: {
    brand: { name: 'അയ്യപ്പൻകാട് അയ്യപ്പ ക്ഷേത്രം', tag: 'ഭക്തി • പൈതൃകം • നവീകരണം' },
    nav: { home: 'ഹോം', about: 'ക്ഷേത്രം', renovation: 'പുനരുദ്ധാരണം', gallery: 'ഗാലറി', festivals: 'ഉത്സവങ്ങൾ', contact: 'ബന്ധപ്പെടുക' },
    hero: {
      slides: [
        { eyebrow: 'സ്വാമിയേ ശരണം അയ്യപ്പാ', title: 'അയ്യപ്പൻകാട് അയ്യപ്പ ക്ഷേത്രം', text: 'ഭക്തരുടെ ഭക്തിയാൽ വീണ്ടും ഉയരുന്ന അയ്യപ്പസ്വാമിയുടെ പുരാതന സന്നിധി.' },
        { eyebrow: 'ക്ഷേത്ര പുനരുദ്ധാരണം', title: 'നൂറ്റാണ്ടുകൾ പഴക്കമുള്ള ക്ഷേത്രം വീണ്ടെടുക്കാൻ കൈകോർക്കാം', text: 'അയ്യപ്പൻകാട് ക്ഷേത്രം പുനർനിർമ്മിക്കാൻ ഭക്തർ ഒന്നിക്കുന്നു. ഈ പുണ്യകർമ്മത്തിൽ പങ്കുചേരുക.' },
        { eyebrow: 'ഭക്തിയുടെ പ്രകാശം', title: 'ഓരോ ദീപത്തിലും ഒരു പ്രാർത്ഥന', text: 'നിത്യപൂജകൾ, വിളക്ക് ഉത്സവങ്ങൾ, കേരളഗ്രാമത്തിന്റെ ശാന്തത.' },
      ],
      cta1: 'പുനരുദ്ധാരണത്തിന് സഹായിക്കുക', cta2: 'ക്ഷേത്രത്തെ അറിയുക',
    },
    about: {
      eyebrow: 'ക്ഷേത്ര പരിചയം', title: 'ധർമ്മശാസ്താവിന്റെ കാലാതീത സന്നിധി',
      p1: 'അയ്യപ്പൻകാട് അയ്യപ്പ ക്ഷേത്രം നൂറ്റാണ്ടുകളായി നാട്ടുകാരുടെ വിശ്വാസകേന്ദ്രമാണ്. ഒരിക്കൽ നിത്യാരാധനയാൽ സമൃദ്ധമായിരുന്ന ഈ പുണ്യഭൂമി ഇന്ന് ഭക്തരുടെ കൈത്താങ്ങിനായി കാത്തിരിക്കുന്നു.',
      p2: 'വനിതകളുടെ നേതൃത്വത്തിൽ ഒരു കൂട്ടം ഭക്തർ ദേവപ്രശ്നത്തിന്റെയും പാരമ്പര്യത്തിന്റെയും വഴിയിൽ ക്ഷേത്രം പുനരുദ്ധരിക്കാൻ ആരംഭിച്ചിരിക്കുന്നു.',
      deity: 'പ്രതിഷ്ഠ', deityV: 'ശ്രീ ധർമ്മശാസ്താവ് (അയ്യപ്പൻ)', location: 'സ്ഥലം', locationV: 'അയ്യപ്പൻകാട്, കേരളം', est: 'സ്ഥാപനം', estV: 'നൂറ്റാണ്ടുകൾ പഴക്കം', more: 'കൂടുതൽ വായിക്കുക',
      historyTitle: 'ക്ഷേത്ര ചരിത്രം', history: 'അയ്യപ്പൻകാട് എന്ന പേരിൽ അറിയപ്പെടുന്ന ഈ ക്ഷേത്രം തലമുറകളായി സംരക്ഷിക്കപ്പെട്ടിരുന്നു. പണ്ട് 40 സെന്റ് ഭൂമി ക്ഷേത്രത്തിനായി മാറ്റിവച്ചിരുന്നതായി നാട്ടുകാർ ഓർക്കുന്നു. ഇന്ന് ക്ഷേത്രം പൂർണ്ണമായി തകർന്ന നിലയിലാണ്; അതിനെ വീണ്ടും ജീവിപ്പിക്കാൻ നാട് ഒന്നിച്ചിരിക്കുന്നു.',
    },
    abx: {
      journeyEyebrow: 'ഞങ്ങളുടെ യാത്ര ഇതുവരെ',
      journeyTitle: 'ക്ഷേത്രത്തെ ഉണർത്തിയ നിമിഷങ്ങൾ',
      journeySub: 'കാട്ടിലെ ആദ്യ ഭജന മുതൽ പുതിയ ക്ഷേത്രത്തിന്റെ ശിലാസ്ഥാപനം വരെ.',
      journey: [
        'കാട്ടിൽ പായ വിരിച്ച് ആദ്യമായി ഭജന ചൊല്ലിയ അമ്മമാർ',
        'ദേവപ്രശ്നം നടന്ന ദിവസം ആനകളുടെ ക്ഷേത്രസന്ദർശനം',
        'വിഗ്രഹം ശുദ്ധീകരിച്ച ശേഷം പൂജ',
        'അലങ്കാരം',
        'ക്ഷേത്രമുറ്റത്ത് ആദ്യമായി പായസം വയ്ക്കുന്നു',
        'കലവറ നിറയ്ക്കൽ',
        'ഗണപതിഹോമത്തിന് മുമ്പുള്ള വിഗ്രഹാലങ്കാരം (ഭഗവതി സേവ)',
        'ഗണപതി ഹോമം',
        'നാലകത്ത് ഇല്ലത്ത് അമ്മയുടെ പൂജ',
        'നാരായണീയ പാരായണം',
        'ഭഗവാന് മാലകെട്ടൽ',
        'ആദ്യത്തെ സപ്താഹം',
        'ഇപ്പോഴത്തെ സ്ഥലം ഉടമയുടെ സന്ദർശനം',
        'ദേവപ്രശ്നം',
        'ഭൂമിപൂജ',
        'ശ്രീ സതീഷ് മേനോൻ കുറ്റിയടിക്കൽ കർമ്മം നിർവഹിക്കുന്നു',
        'വീട്ടമ്മമാർ മാസംതോറും നടത്തിവരുന്ന ഭജന',
        'ഒരു ക്ഷേത്രം ഉയർത്തുവാൻ അമ്മമാരുടെ പ്രാർത്ഥന',
        'സപ്താഹം: ശ്രീകൃഷ്ണനും രുഗ്മിണിയും',
        'രുഗ്മിണിയെ കൊണ്ടുവരുന്നു',
      ],
      deityEyebrow: 'പുണ്യരൂപം',
      deityTitle: 'അയ്യപ്പൻകാടിലെ വിഗ്രഹം',
      deitySub: 'വിഗ്രഹത്തിന്റെ ഓരോ സവിശേഷതയ്ക്കും ഒരു അർത്ഥമുണ്ട്.',
      tableHead: ['ശരീരഭാഗം', 'പ്രത്യേകത', 'സാധ്യതയുള്ള അർത്ഥം'],
      form: [
        { p: 'തല', f: 'മയിൽപ്പീലി വിടർത്തിയതുപോലുള്ള ജടകൾ', m: 'തപസ്സ്, യോഗശക്തി' },
        { p: 'ശിരോഭാഗം', f: 'ഇരുവശത്തേക്കും വിരിയുന്ന അലങ്കാരം', m: 'ജടാമകുടത്തിന്റെ പ്രത്യേക രൂപം' },
        { p: 'തലയ്ക്കു പിന്നിൽ', f: 'വൃത്താകൃതിയിലുള്ള പ്രഭാവലയം', m: 'ദിവ്യത്വം, തേജസ്സ്' },
        { p: 'കണ്ണുകൾ', f: 'പാതി തുറന്ന നില', m: 'ധ്യാനവും ജാഗ്രതയും' },
        { p: 'ഇരിപ്പ്', f: 'പത്മാസനം', m: 'യോഗവും ആത്മനിയന്ത്രണവും' },
        { p: 'ഇടതുകൈ', f: 'തുടയിൽ വിശ്രമിക്കുന്നു', m: 'ധ്യാനഭാവം' },
        { p: 'വലതുകൈ', f: 'ചൂണ്ടുവിരലിനും നടുവിരലിനുമിടയിൽ വസ്തു പിടിച്ചിരിക്കുന്നു', m: 'ആയുധമോ ആചാരോപകരണമോ ആകാം' },
        { p: 'വയർ', f: 'കുറുകെ ഒരു നാടപോലുള്ള പട്ട', m: 'ഉദരബന്ധം' },
        { p: 'കഴുത്ത്', f: 'മാലകളും രുദ്രാക്ഷവും', m: 'തപസ്സ്, ആത്മീയത' },
      ],
      chipsTitle: 'യോഗീശ്വരന്റെ പ്രതീകങ്ങൾ',
      chips: [
        ['പത്മാസനം', 'ആത്മനിയന്ത്രണം'],
        ['ജടാമകുടം', 'തപശ്ശക്തി'],
        ['രുദ്രാക്ഷം', 'വൈരാഗ്യം'],
        ['പാശം', 'ബന്ധനശക്തി'],
        ['അങ്കുശം', 'നിയന്ത്രണശക്തി'],
        ['പ്രഭാമണ്ഡലം', 'ദിവ്യത്വം'],
      ],
      tattvaEyebrow: 'വഴികാട്ടുന്ന സങ്കൽപ്പം',
      mantra: 'പാശേന ബധ്നാതി, അങ്കുശേന നയതി',
      mantraMeaning: 'പാശത്താൽ അധർമ്മത്തിൽനിന്ന് തിരിച്ചുപിടിക്കുകയും അങ്കുശത്താൽ ധർമ്മമാർഗത്തിലേക്ക് നയിക്കുകയും ചെയ്യുന്ന ധർമ്മശാസ്താവ്; ധ്യാനനിരതനായ യോഗിയും ധർമ്മം നടപ്പാക്കുന്ന ശാസകനും വനജീവിതത്തിന്റെ സംരക്ഷകനും.',
      roles: [
        { t: 'പാശം', pts: ['അധർമ്മബന്ധനത്തിൽനിന്ന് തിരിച്ചുകൊണ്ടുവരുന്നു', 'തെറ്റായ പ്രവൃത്തികളെ ബന്ധിക്കുന്നു', 'അച്ചടക്കവും നീതിയും നൽകുന്നു'] },
        { t: 'അങ്കുശം', pts: ['ധർമ്മമാർഗത്തിലേക്ക് നയിക്കുന്നു', 'മനസ്സിനെയും ഇന്ദ്രിയങ്ങളെയും നിയന്ത്രിക്കുന്നു', 'ദിശാബോധം നൽകുന്നു'] },
      ],
      shaktiEyebrow: 'ദിവ്യശക്തികൾ',
      shaktiTitle: 'ധർമ്മശാസ്താവിന്റെ പന്ത്രണ്ട് ശക്തികൾ',
      shaktiSub: 'വെറും അത്ഭുതശക്തികളല്ല; മനുഷ്യനെ ധർമ്മത്തിലേക്ക് നയിക്കുകയും പ്രകൃതിയെ സംരക്ഷിക്കുകയും ആത്മീയമായി ഉയർത്തുകയും ചെയ്യുന്ന ശക്തികൾ.',
      shaktis: [
        { t: 'ജ്ഞാനശക്തി', d: 'അജ്ഞാനത്തെ നീക്കി വിവേകവും ശരിയായ തീരുമാനമെടുക്കാനുള്ള കഴിവും നൽകുന്നു. ഗുരുവായും അധ്യാപകനായും അനുഗ്രഹിക്കുന്നു.' },
        { t: 'പാശശക്തി', d: 'തെറ്റായ വഴികളിൽ അകപ്പെടുന്നവരെ ധർമ്മവുമായി ബന്ധിപ്പിക്കുന്നു. ദുഷ്പ്രവണതകളിൽനിന്ന് മോചിതരാകാനുള്ള ആത്മനിയന്ത്രണം നൽകുന്നു.' },
        { t: 'അങ്കുശശക്തി', d: 'വഴിതെറ്റുന്ന മനസ്സിനെയും ഇന്ദ്രിയങ്ങളെയും നിയന്ത്രിച്ച് ശരിയായ ദിശയിലേക്ക് നയിക്കുന്നു.' },
        { t: 'അഭയശക്തി', d: 'ഭയം, അരക്ഷിതാവസ്ഥ, നിരാശ എന്നിവയെ അതിജീവിക്കാനുള്ള ധൈര്യവും ആത്മവിശ്വാസവും നൽകുന്നു.' },
        { t: 'വീരശക്തി', d: 'അനീതിക്കെതിരെ നിലകൊള്ളാനും ദുർബലരെ സംരക്ഷിക്കാനും ധൈര്യവും മനോബലവും നൽകുന്നു.' },
        { t: 'യോഗശക്തി', d: 'മനസ്സിന്റെയും ശരീരത്തിന്റെയും ഇന്ദ്രിയങ്ങളുടെയും സമതുലിതാവസ്ഥയും ധ്യാനശേഷിയും വളർത്തുന്നു.' },
        { t: 'അനുഗ്രഹശക്തി', d: 'ജീവിതത്തിലെ പ്രതിസന്ധികളെ നേരിടാനുള്ള പ്രത്യാശയും ആത്മവിശ്വാസവും നൽകുന്നു. സത്കർമ്മങ്ങൾക്ക് പ്രചോദനമാകുന്നു.' },
        { t: 'പ്രകൃതിസംരക്ഷണശക്തി', d: 'വനങ്ങൾ, മൃഗങ്ങൾ, പക്ഷികൾ, ജലസ്രോതസ്സുകൾ, പ്രകൃതിസമ്പത്ത് എന്നിവയോടുള്ള സംരക്ഷണബോധം വളർത്തുന്നു.' },
        { t: 'ന്യായശക്തി', d: 'നീതിബോധം, സത്യസന്ധത, ഉത്തരവാദിത്വം, ധാർമ്മികമായ ഭരണബോധം എന്നിവ വളർത്തുന്നു.' },
        { t: 'തപശ്ശക്തി', d: 'ആത്മനിയന്ത്രണം, ക്ഷമ, സഹനശക്തി, ഇച്ഛാശക്തി എന്നിവ വർധിപ്പിക്കുന്നു.' },
        { t: 'രക്ഷാശക്തി', d: 'കുടുംബത്തിലും സമൂഹത്തിലും പരസ്പരസ്നേഹം, സുരക്ഷാബോധം, സഹകരണം എന്നിവ നിലനിർത്താൻ പ്രചോദിപ്പിക്കുന്നു.' },
        { t: 'മോക്ഷശക്തി', d: 'അഹങ്കാരം, ആസക്തി, അജ്ഞാനം എന്നിവയിൽനിന്ന് മുക്തനായി ആത്മീയമായ ഉന്നതിയിലേക്ക് നയിക്കുന്നു.' },
      ],
      note: 'വിഗ്രഹത്തെയും പ്രതീകങ്ങളെയും കുറിച്ചുള്ള വ്യാഖ്യാനങ്ങൾ ഭക്തിപാരമ്പര്യത്തെ അടിസ്ഥാനമാക്കിയുള്ളതാണ്; പണ്ഡിതർക്കും ക്ഷേത്രപാരമ്പര്യങ്ങൾക്കും ഇടയിൽ ഇവ വ്യത്യാസപ്പെടാം.',
    },
    quick: ['ക്ഷേത്ര ചരിത്രം', 'പൂജകളും ചടങ്ങുകളും', 'ഉത്സവ വിവരങ്ങൾ', 'ഗാലറി', 'എത്തിച്ചേരുക'],
    highlights: {
      title: 'ക്ഷേത്ര വിശേഷങ്ങൾ', sub: 'അയ്യപ്പൻകാടിന്റെ ദിവ്യസൗന്ദര്യവും ആത്മീയതയും അനുഭവിക്കുക.',
      items: [
        { t: 'പുണ്യ പൈതൃകം', d: 'നൂറ്റാണ്ടുകളുടെ ആരാധനയും നാട്ടുപാരമ്പര്യവും.' },
        { t: 'അയ്യപ്പസ്വാമി', d: 'എല്ലാ ഭക്തർക്കും ധർമ്മശാസ്താവിന്റെ അനുഗ്രഹം.' },
        { t: 'നിത്യപൂജകൾ', d: 'ദിവസേനയുള്ള പൂജകളും വഴിപാടുകളും.' },
        { t: 'ഉത്സവങ്ങൾ', d: 'വിളക്ക്, മണ്ഡലപൂജ തുടങ്ങിയവ.' },
        { t: 'ശാന്തമായ പരിസരം', d: 'കേരളഗ്രാമത്തിന്റെ ശാന്തത.' },
        { t: 'സമൂഹ സേവനം', d: 'ഭക്തർ നയിക്കുന്നു, എല്ലാവരും പിന്തുണയ്ക്കുന്നു.' },
      ],
    },
    deities: {
      title: 'ക്ഷേത്രത്തിലെ പ്രതിഷ്ഠകൾ',
      sub: 'അയ്യപ്പൻകാടിൽ ഓരോ ഭക്തനെയും അനുഗ്രഹിക്കുന്ന പ്രധാന, ഉപദേവതകൾ.',
      items: [
        { tag: 'മുഖ്യ പ്രതിഷ്ഠ', name: 'ശ്രീ അയ്യപ്പൻ', d: 'ധ്യാനനിരതനായ യോഗിയും ധർമ്മത്തിന്റെ സംരക്ഷകനും വനത്തിന്റെ കാവലാളുമായ ധർമ്മശാസ്താവ്.' },
        { tag: 'പ്രതിഷ്ഠ 1', name: 'ദേവി', d: 'ശ്രീകോവിലിനടുത്ത് കുടികൊള്ളുന്ന, എല്ലാ ഭക്തർക്കും കാരുണ്യം ചൊരിയുന്ന ജഗദംബ.' },
        { tag: 'പ്രതിഷ്ഠ 2', name: 'ശ്രീ ഗണപതി', d: 'വിഘ്നങ്ങൾ നീക്കുന്ന ദേവൻ; ഓരോ പൂജയുടെയും ശുഭകർമ്മത്തിന്റെയും തുടക്കത്തിൽ സ്മരിക്കപ്പെടുന്നു.' },
      ],
    },
    silas: {
      eyebrow: 'വരാനിരിക്കുന്ന ചടങ്ങ്',
      title: 'ശിലാസ്ഥാപനം',
      subtitle: 'ശിലാസ്ഥാപന ചടങ്ങ്',
      temple: 'അയ്യപ്പൻകാട് അയ്യപ്പൻ ക്ഷേത്രം, പുതുശ്ശേരി, പാലക്കാട്',
      dateL: 'തീയതി', date: '2026 നവംബർ 5, വ്യാഴാഴ്ച',
      timeL: 'സമയം', time: 'രാവിലെ 7.10നും 9.20നും മധ്യേ',
      guestsT: 'സാന്നിധ്യം',
      guests: [
        { n: 'സന്യാസി ഉദിത് ചൈതന്യ', r: 'ഭാഗവതഗ്രാമം' },
        { n: 'സന്യാസി സ്വരൂപാനന്ദ സരസ്വതി', r: 'ശിവാനന്ദാശ്രമം, പാലക്കാട്' },
        { n: 'ഡോ. ശ്യാം പ്രസാദ്', r: 'മേൽശാന്തി, ആനിക്കോട് അൻപുമൂർത്തി ക്ഷേത്രം' },
      ],
      orgL: 'സംഘാടകർ', org: 'സാന്ദീപനി സാധനാലയം ചാരിറ്റബിൾ & വെൽഫെയർ ട്രസ്റ്റ്',
      phone: '9847960323',
      invite: 'ചടങ്ങിൽ പങ്കെടുത്ത് അനുഗ്രഹം നേടാൻ എല്ലാ ഭക്തജനങ്ങളെയും സ്നേഹപൂർവ്വം ക്ഷണിക്കുന്നു.',
      cdT: 'ചടങ്ങിലേക്കുള്ള സമയം', dLabel: 'ദിവസം', hLabel: 'മണിക്കൂർ', mLabel: 'മിനിറ്റ്',
      done: 'ശുഭമുഹൂർത്തം സമാഗതമായി. സ്വാമിയേ ശരണം അയ്യപ്പാ!',
      cta2: 'പുനരുദ്ധാരണത്തിന് സഹായിക്കുക',
      jrTitle: 'പുതിയ ക്ഷേത്രത്തിലേക്കുള്ള ചുവടുകൾ',
      jrSub: 'പുനരുദ്ധാരണ യാത്രയിലെ സമീപകാല നിമിഷങ്ങൾ.',
      jrAll: 'മുഴുവൻ യാത്രയും കാണുക',
    },
    gallery: {
      title: 'ക്ഷേത്ര ദർശന കാഴ്ചകൾ', sub: 'ക്ഷേത്രത്തിലെ ദിവ്യ നിമിഷങ്ങൾ.', all: 'എല്ലാ ചിത്രങ്ങളും കാണുക',
      eyebrow: 'പുണ്യ നിമിഷങ്ങൾ', photos: 'ചിത്രങ്ങൾ', hint: 'ഏതെങ്കിലും ചിത്രത്തിൽ തൊട്ട് വലുതായി കാണുക',
      mosaic: 'മൊസൈക്', grid: 'ഗ്രിഡ്', view: 'ചിത്രം കാണുക', close: 'അടയ്ക്കുക', prev: 'മുമ്പത്തെ', next: 'അടുത്തത്',
      loadMore: 'കൂടുതൽ ചിത്രങ്ങൾ കാണുക', introEyebrow: 'ഞങ്ങളുടെ ഗാലറി', introTitle: 'പുണ്യസന്നിധിയുടെ കാഴ്ചകൾ',
      introText: 'അയ്യപ്പൻകാടിലെ ചിത്രങ്ങളും വീഡിയോകളും കാണാം: നിത്യപൂജകൾ, ഉത്സവദീപങ്ങൾ, ശാന്തമായ ഗ്രാമക്ഷേത്രം, ക്ഷേത്രം വീണ്ടെടുക്കാൻ പ്രയത്നിക്കുന്ന നാടിന്റെ ഭക്തി.',
      videos: 'വീഡിയോകൾ', heritage: 'പൈതൃകം', centuries: 'നൂറ്റാണ്ടുകൾ',
      momentsEyebrow: 'നിങ്ങൾക്ക് കാണാവുന്നത്', momentsTitle: 'ഞങ്ങൾ നെഞ്ചേറ്റുന്ന നിമിഷങ്ങൾ',
      moments: [
        { t: 'നിത്യപൂജകൾ', d: 'ക്ഷേത്രത്തെ ഉണർത്തുന്ന പ്രഭാത, സന്ധ്യാ പ്രാർത്ഥനകൾ.' },
        { t: 'ഉത്സവദീപങ്ങൾ', d: 'ക്ഷേത്രമുറ്റത്ത് തെളിയുന്ന വിളക്കുനിരകൾ.' },
        { t: 'ഗ്രാമക്ഷേത്രം', d: 'കേരളഗ്രാമക്ഷേത്രത്തിന്റെ ശാന്തസൗന്ദര്യം.' },
        { t: 'പുനരുദ്ധാരണ സേവനം', d: 'ക്ഷേത്രം പുനർനിർമ്മിക്കാൻ ഒന്നിക്കുന്ന ഭക്തർ.' },
      ],
      videosEyebrow: 'കാണുക', videosTitle: 'ക്ഷേത്ര വീഡിയോകൾ', videosSub: 'വീഡിയോയിൽ തൊട്ട് വലുതായി കാണുക.',
      videoTitles: ['ക്ഷേത്ര ദർശനം', 'ഉത്സവ വിളക്ക്', 'പുനരുദ്ധാരണ സേവനം', 'ഗ്രാമക്ഷേത്രം'],
      play: 'വീഡിയോ പ്ലേ ചെയ്യുക',
      ctaTitle: 'ഞങ്ങളുടെ കഥയുടെ ഭാഗമാകൂ', ctaText: 'ക്ഷേത്രം സന്ദർശിക്കൂ, ഉത്സവങ്ങളിൽ പങ്കുചേരൂ, ക്ഷേത്രത്തെ വീണ്ടും ജീവിപ്പിക്കാൻ സഹായിക്കൂ.',
      ctaBtn1: 'പുനരുദ്ധാരണത്തിന് സഹായിക്കുക', ctaBtn2: 'സമിതിയെ ബന്ധപ്പെടുക',

    },
    festivals: {
      title: 'ഉത്സവങ്ങൾ', sub: 'ക്ഷേത്രത്തിലെ വിശേഷ ഉത്സവങ്ങൾ.', all: 'എല്ലാ ഉത്സവങ്ങളും കാണുക', learn: 'കൂടുതൽ അറിയുക',
      items: [
        { m: 'ജനുവരി – ഫെബ്രുവരി', t: 'മകരവിളക്ക്', d: 'വിശേഷ ദർശനം, ദീപങ്ങൾ, കലാപരിപാടികൾ.' },
        { m: 'നവംബർ – ഡിസംബർ', t: 'മണ്ഡല പൂജ', d: 'നാല്പത്തിയൊന്ന് ദിവസത്തെ വ്രതവും മഹാപൂജയും.' },
        { m: 'കാർത്തിക മാസം', t: 'കാർത്തിക വിളക്ക്', d: 'ക്ഷേത്രമുറ്റത്ത് ദീപം തെളിയിക്കൽ.' },
        { m: 'ഡിസംബർ – ജനുവരി', t: 'ശബരിമല യാത്ര', d: 'ഇരുമുടിക്കെട്ടോടെ തീർത്ഥാടനം ആരംഭിക്കുന്നു.' },
      ],
    },
    festPage: {
      vzEyebrow: 'വിശേഷ വഴിപാടുകൾ',
      vzTitle: 'വിശേഷ വഴിപാടുകൾ',
      vzSub: 'ക്ഷേത്രത്തിൽ ഭക്തർക്ക് സമർപ്പിക്കാവുന്ന വിശേഷ വഴിപാടുകൾ.',
      vzItems: [
        {
          t: 'നെയ്‌വിളക്ക്', ml: '', tag: 'വഴിപാട്',
          d: 'ഭക്തിയുടെയും പ്രാർത്ഥനയുടെയും പ്രകാശമായി ഭഗവാന്റെ മുന്നിൽ ശുദ്ധമായ നെയ്യ് കൊണ്ട് വിളക്ക് തെളിയിക്കുന്നു.',
        },
        {
          t: 'എഴുതിരി കത്തിക്കൽ', ml: '', tag: 'എല്ലാ ശനിയാഴ്ചയും',
          d: 'എല്ലാ ശനിയാഴ്ചയും ദേവന്റെ മുന്നിൽ എഴുതിരി വിളക്ക് തെളിയിക്കുന്ന വഴിപാട്.',
        },
        {
          t: 'നീരാഞ്ജനം', ml: '', tag: 'പൂജ',
          d: 'വിഘ്നങ്ങൾ നീങ്ങാനും അയ്യപ്പസ്വാമിയുടെ അനുഗ്രഹത്തിനുമായി പ്രാർത്ഥനയോടെ സമർപ്പിക്കുന്ന പരമ്പരാഗത ദീപവഴിപാട്.',
        },
      ],
      vzNote: 'വഴിപാടുകൾ ബുക്ക് ചെയ്യാനും സമയം അറിയാനും സമിതിയെ ബന്ധപ്പെടുക.',
      eyebrow: 'ചടങ്ങ്',
      intro: 'വർഷം മുഴുവൻ ദീപങ്ങളും വ്രതവും പ്രാർത്ഥനയും കൊണ്ട് ക്ഷേത്രം ഉണർന്നിരിക്കുന്നു. ഓരോ ഉത്സവവും ഭക്തർക്ക് ഒത്തുചേരാനും ധർമ്മശാസ്താവിന്റെ അനുഗ്രഹം നേടാനുമുള്ള അവസരമാണ്.',
      stats: [
        { v: '4', l: 'പ്രധാന ഉത്സവങ്ങൾ' },
        { v: '41', l: 'ദിവസത്തെ മണ്ഡല വ്രതം' },
        { v: 'നവം – ഫെബ്രു', l: 'ഉത്സവകാലം' },
        { v: 'എല്ലാവർക്കും', l: 'ഭക്തർക്ക് സ്വാഗതം' },
      ],
      detailsEyebrow: 'ഉത്സവ വിവരങ്ങൾ',
      detailsTitle: 'അയ്യപ്പൻകാടിലെ ചടങ്ങുകൾ',
      highlightsT: 'പതിവ് ചടങ്ങുകൾ',
      items: [
        {
          long: 'മകരസംക്രാന്തിയോടനുബന്ധിച്ചാണ് മകരവിളക്ക് ആഘോഷിക്കുന്നത്. ഋതുമാറ്റത്തിന്റെ ശുഭമുഹൂർത്തത്തിൽ ഭക്തർ ഒത്തുചേരുന്നു. ദീപനിരകളാൽ ക്ഷേത്രം പ്രകാശിക്കുന്നു; വിശേഷ ദർശനവും നാട്ടുകാർക്കായി കലാപരിപാടികളും ഉണ്ടായിരിക്കും.',
          points: ['വിശേഷ ദർശനം', 'സന്ധ്യയ്ക്ക് ദീപം തെളിയിക്കൽ', 'എല്ലാ പ്രായക്കാർക്കും കലാപരിപാടികൾ'],
        },
        {
          long: 'നാല്പത്തിയൊന്ന് ദിവസത്തെ കഠിന വ്രതത്തിന്റെ സമാപനമാണ് മണ്ഡലപൂജ. ഭക്തർ ലളിതജീവിതം നയിച്ച് മാല ധരിച്ച് ദിവസേന ക്ഷേത്രദർശനം നടത്തുന്നു; മണ്ഡലകാലത്തിന്റെ അവസാനം മഹാപൂജയോടെ സമാപിക്കുന്നു.',
          points: ['നാല്പത്തിയൊന്ന് ദിവസത്തെ വ്രതം', 'നിത്യപ്രാർത്ഥനയും ഭജനയും', 'അവസാന ദിവസം മഹാപൂജ'],
        },
        {
          long: 'കാർത്തിക വിളക്കിന് ക്ഷേത്രമുറ്റത്താകെ ദീപങ്ങൾ തെളിയിക്കുന്നു. കുടുംബങ്ങളും അയൽക്കാരും ഒത്തുചേരുമ്പോൾ ക്ഷേത്രപരിസരം ഭക്തിയുടെ പ്രകാശത്താൽ നിറയുന്നു.',
          points: ['ക്ഷേത്രമുറ്റത്ത് ദീപങ്ങൾ', 'സന്ധ്യാപ്രാർത്ഥന', 'നാടൊന്നാകെ പങ്കാളിത്തം'],
        },
        {
          long: 'തീർത്ഥാടകർ ശിരസ്സിലേന്തുന്ന പുണ്യകെട്ടായ ഇരുമുടിയോടെയാണ് ശബരിമല യാത്ര ആരംഭിക്കുന്നത്. പ്രാർത്ഥനയോടും വ്രതത്തോടും കൂടി ഒരുങ്ങി അയ്യപ്പസ്വാമിയുടെ അനുഗ്രഹത്തോടെ ഭക്തർ ഒന്നിച്ച് യാത്രയാകുന്നു.',
          points: ['ഇരുമുടി ഒരുക്കൽ', 'യാത്രയ്ക്ക് മുമ്പുള്ള പ്രാർത്ഥന', 'തീർത്ഥാടകർ ഒന്നിച്ച് പുറപ്പെടുന്നു'],
        },
      ],
      calEyebrow: 'മുൻകൂട്ടി അറിയാൻ',
      calTitle: 'ഉത്സവകാലം ഒറ്റനോട്ടത്തിൽ',
      calSub: 'അടയാളപ്പെടുത്തിയ മാസങ്ങളിൽ ഓരോ ഉത്സവവും ആചരിക്കുന്നു.',
      months: ['ജനു', 'ഫെബ്രു', 'മാർ', 'ഏപ്രി', 'മേയ്', 'ജൂൺ', 'ജൂലൈ', 'ഓഗ', 'സെപ്റ്റ', 'ഒക്ടോ', 'നവം', 'ഡിസം'],
      guideEyebrow: 'ഭക്തർക്ക്',
      guideTitle: 'ഉത്സവങ്ങൾ ആചരിക്കുമ്പോൾ',
      guide: [
        { t: 'വ്രതം', d: 'ആചരണകാലത്ത് ലളിതവും ചിട്ടയുമുള്ള ജീവിതവും പ്രാർത്ഥനയും ശുദ്ധമനസ്സും പാലിക്കുക.' },
        { t: 'വസ്ത്രധാരണം', d: 'ക്ഷേത്രദർശനത്തിന് പരമ്പരാഗതവും ലളിതവുമായ വസ്ത്രം ധരിക്കുക.' },
        { t: 'വഴിപാടുകൾ', d: 'പൂക്കൾ, ദീപത്തിനുള്ള എണ്ണ, അല്ലെങ്കിൽ ഭക്തിയോടെയുള്ള ഏതു സമർപ്പണവും കൊണ്ടുവരാം.' },
        { t: 'ഒരുമിച്ച്', d: 'സമൂഹത്തോടൊപ്പം ചേരുക, സേവനത്തിൽ പങ്കാളിയാകുക, ക്ഷേത്രപരിസരം ശുചിയായും ശാന്തമായും സൂക്ഷിക്കുക.' },
      ],
      note: 'തീയതികൾ പരമ്പരാഗത ക്ഷേത്ര കലണ്ടർ പ്രകാരമാണ്; ഓരോ വർഷവും മാറാം. സ്ഥിരീകരിച്ച തീയതികൾക്ക് സമിതിയെ ബന്ധപ്പെടുക.',
      ctaTitle: 'ഞങ്ങളോടൊപ്പം ആഘോഷിക്കൂ',
      ctaText: 'ഉത്സവങ്ങളിൽ പങ്കുചേരൂ, സേവനം നൽകൂ, ക്ഷേത്രത്തെ വീണ്ടും ജീവിപ്പിക്കാൻ സഹായിക്കൂ.',
      ctaBtn1: 'സമിതിയെ ബന്ധപ്പെടുക',
      ctaBtn2: 'പുനരുദ്ധാരണത്തിന് സഹായിക്കുക',
    },
    visit: {
      title: 'ദർശനത്തിനായി', sub: 'ദിവ്യാനുഗ്രഹത്തിലേക്കുള്ള യാത്ര ഇവിടെ തുടങ്ങുന്നു.', timingsT: 'ദർശന സമയം', timings: 'നിലവിലെ സമയത്തിന് സമിതിയെ ബന്ധപ്പെടുക', locT: 'സ്ഥലം', loc: 'അയ്യപ്പൻകാട്, കേരളം', guideT: 'സന്ദർശകർക്ക്', guide: 'പരമ്പരാഗത വസ്ത്രധാരണം • ക്ഷേത്രചിട്ടകൾ പാലിക്കുക', directions: 'വഴി കാണുക',
    },
    reno: {
      title: 'ക്ഷേത്ര പുനരുദ്ധാരണം', sub: 'എല്ലാ ഭക്തരോടുമുള്ള ഹൃദയപൂർവ്വമായ അഭ്യർത്ഥന', greeting: 'പ്രിയ ഭക്തജനങ്ങളേ,',
      paras: [
        'നൂറ്റാണ്ടുകളായി അയ്യപ്പൻകാട് എന്ന പേരിൽ അറിയപ്പെടുന്ന അയ്യപ്പൻകാട് അയ്യപ്പ ക്ഷേത്രം ഇന്ന് പൂർണ്ണമായും തകർന്ന അവസ്ഥയിലാണ്. ഇത് അയ്യപ്പഭക്തർക്ക് ഏറെ ദുഃഖകരമായ കാര്യമാണ്.',
        'വനിതകളുടെ നേതൃത്വത്തിൽ ഒരു കൂട്ടം ഭക്തർ ക്ഷേത്രം പുനരുദ്ധരിക്കാനുള്ള ശ്രമങ്ങൾ ആരംഭിച്ചിട്ടുണ്ട്. നാട്ടുകാരിൽ നിന്ന് ലഭിച്ച വിവരമനുസരിച്ച് പണ്ട് 40 സെന്റ് ഭൂമി ക്ഷേത്രത്തിനായി മാറ്റിവച്ചിരുന്നു. മുൻകാല അവകാശികൾ ഇന്ന് ജീവിച്ചിരിപ്പില്ലെങ്കിലും ഈ ഭൂമി ക്ഷേത്രസ്വത്തായി സംരക്ഷിക്കപ്പെട്ടിരുന്നതായി നാട്ടുകാർക്കറിയാം.',
        'ക്ഷേത്ര പുനർനിർമ്മാണം തുടങ്ങുന്നതിന് മുമ്പ് ഭൂമിസംബന്ധമായ കാര്യങ്ങൾ പരിഹരിക്കണമെന്ന് ദേവപ്രശ്നത്തിൽ കണ്ടിരുന്നു. അതനുസരിച്ച് ഭക്തർ ആവശ്യമായ നടപടികൾ സ്വീകരിച്ചുവരുന്നു.',
        'ക്ഷേത്രസ്വത്തായി തിരിച്ചറിഞ്ഞിരിക്കുന്ന ഭൂമി ഇപ്പോൾ സംരക്ഷിച്ചുവരുന്നു. ഭൂമിയിൽ യഥാർത്ഥ അവകാശമുള്ളവർ ബന്ധപ്പെട്ട രേഖകളുമായി മുന്നോട്ടു വരണമെന്ന് അഭ്യർത്ഥിക്കുന്നു.',
        'പരസ്പര ധാരണയോടെയും സഹകരണത്തോടെയും സൗഹൃദ ചർച്ചകളിലൂടെയും എല്ലാ കാര്യങ്ങളും പരിഹരിക്കാനാകുമെന്ന് ഞങ്ങൾ ആത്മാർത്ഥമായി പ്രതീക്ഷിക്കുന്നു. ഈ വിഷയങ്ങൾ സൗഹാർദ്ദപരമായി പരിഹരിക്കാൻ എല്ലാവരും സഹകരിക്കണമെന്ന് വിനയപൂർവ്വം അഭ്യർത്ഥിക്കുന്നു.',
        'സമീപവാസികളും നാട്ടുകാരും എല്ലാ ഭക്തജനങ്ങളും ഈ അറിയിപ്പ് സഹകരണത്തിനായുള്ള ആത്മാർത്ഥമായ അഭ്യർത്ഥനയായി കണക്കാക്കി ക്ഷേത്ര പുനരുദ്ധാരണ പ്രവർത്തനങ്ങൾക്ക് പിന്തുണ നൽകണമെന്ന് വിനയപൂർവ്വം അപേക്ഷിക്കുന്നു.',
      ],
      saranam: 'സ്വാമിയേ ശരണം അയ്യപ്പാ!!', org: 'അയ്യപ്പൻകാട് അയ്യപ്പ സേവാ സമിതി', behalf: 'അംഗങ്ങൾക്കുവേണ്ടി',
      stepsTitle: 'ഞങ്ങളുടെ മുന്നോട്ടുള്ള വഴി',
      steps: ['ദേവപ്രശ്ന നിർദ്ദേശം', 'ക്ഷേത്രഭൂമി സംരക്ഷണം', 'അവകാശങ്ങൾ സൗഹൃദമായി പരിഹരിക്കൽ', 'ക്ഷേത്ര പുനർനിർമ്മാണം'],
      cta: 'സമിതിയെ ബന്ധപ്പെടുക',
    },
    renoPage: {
      eyebrow: 'ഹൃദയപൂർവ്വമായ അഭ്യർത്ഥന',
      facts: [
        { v: 'നൂറ്റാണ്ടുകൾ', l: 'ക്ഷേത്ര പൈതൃകം' },
        { v: '40 സെന്റ്', l: 'ക്ഷേത്രത്തിനായി മാറ്റിവച്ച ഭൂമി' },
        { v: 'ദേവപ്രശ്നം', l: 'ഓരോ ചുവടിലും വഴികാട്ടി' },
        { v: 'വനിതാ നേതൃത്വം', l: 'ഭക്തരുടെ കൂട്ടായ്മയുടെ നേതൃത്വം' },
      ],
      noticeTag: 'പ്രധാന അറിയിപ്പ്',
      lampEyebrow: 'പ്രാർത്ഥന സമർപ്പിക്കുക',
      lampTitle: 'ക്ഷേത്രത്തിനായി ഒരു ദീപം തെളിയിക്കൂ',
      lampSub: 'ദീപത്തിൽ തൊട്ട് നിങ്ങളുടെ പ്രാർത്ഥനയോടെ തെളിയിക്കുക. ഓരോ നാളവും ക്ഷേത്രം വീണ്ടും ഉയരട്ടെ എന്ന പ്രാർത്ഥനയാണ്.',
      lampsLit: 'ദീപങ്ങൾ തെളിഞ്ഞു',
      lampAll: 'എല്ലാ ദീപങ്ങളും തെളിയിക്കുക',
      lampReset: 'വീണ്ടും തുടങ്ങുക',
      lampBless: 'സ്വാമിയേ ശരണം! നിങ്ങളുടെ പ്രാർത്ഥന സഫലമാകട്ടെ.',
      ctaTitle: 'പുനരുദ്ധാരണത്തിൽ പങ്കാളിയാകൂ',
      ctaText: 'നിങ്ങളുടെ പ്രാർത്ഥനയും സാന്നിധ്യവും പിന്തുണയുമായി മുന്നോട്ടു വരൂ.',
      ctaBtn2: 'ക്ഷേത്രത്തെ അറിയുക',
      structEyebrow: 'പുതിയ ശ്രീകോവിൽ',
      structTitle: 'ക്ഷേത്ര നിർമ്മിതി',
      structSub: 'നിർമ്മാണം പൂർത്തിയാകുമ്പോൾ പരമ്പരാഗത കേരള ശൈലിയിൽ പുനരുദ്ധരിച്ച ക്ഷേത്രം ഇങ്ങനെയായിരിക്കും.',
      renderTag: 'നിർമ്മാണത്തിനു ശേഷം',
      renderCap: 'പൂർത്തിയായ ശ്രീകോവിലുകളുടെ ചിത്രരൂപം',
      blueprintTag: 'യഥാർത്ഥ പ്ലാൻ',
      blueprintCap: 'നിർമ്മാണത്തിനായി തയ്യാറാക്കിയ കൈകൊണ്ട് വരച്ച പ്ലാൻ',
      zoomHint: 'ചിത്രത്തിൽ തൊട്ട് വലുതായി കാണുക',
      closeLabel: 'അടയ്ക്കുക',
      structFeaturesT: 'രൂപകല്പനയുടെ സവിശേഷതകൾ',
      structFeatures: [
        { t: 'ഇരട്ട ശ്രീകോവിൽ', d: 'അടുത്തടുത്തായി രണ്ട് ശ്രീകോവിലുകൾ: ഒന്ന് ധർമ്മശാസ്താവിനും ഒന്ന് ദേവിക്കും.' },
        { t: 'ഓടുമേഞ്ഞ മേൽക്കൂര', d: 'ചുവന്ന കളിമൺ ഓടുകൾ പാകിയ, മനോഹരമായി മുകളിലേക്ക് വളഞ്ഞ കോണുകളുള്ള ചരിഞ്ഞ മേൽക്കൂര.' },
        { t: 'തടി തൂണുകൾ', d: 'കടഞ്ഞെടുത്ത് മിനുക്കിയ തടിത്തൂണുകളും കൊത്തുപണികളുള്ള തടിച്ചുവരുകളും.' },
        { t: 'സ്വർണ്ണ കലശം', d: 'ഓരോ മേൽക്കൂരയുടെയും മുകളിൽ കേരള ക്ഷേത്രങ്ങളുടെ പുണ്യചിഹ്നമായ സ്വർണ്ണ കലശം.' },
        { t: 'കരിങ്കൽ അധിഷ്ഠാനം', d: 'പടികളായി കെട്ടിയ കരിങ്കൽ അധിഷ്ഠാനം ശ്രീകോവിലിനെ ഭൂമിയിൽനിന്ന് ഉയർത്തി നിർത്തുന്നു.' },
        { t: 'തുറന്ന മുറ്റം', d: 'തെങ്ങുകളും പച്ചപ്പും തണൽ നൽകുന്ന, ശാന്തമായ ക്ഷേത്രമുറ്റം.' },
      ],
      structNote: 'ചിത്രങ്ങൾ സൂചനയ്ക്കുവേണ്ടിയുള്ളവയാണ്. ദേവപ്രശ്നത്തിന്റെയും തന്ത്രിയുടെയും നിർദ്ദേശമനുസരിച്ച് അന്തിമ നിർമ്മാണത്തിൽ ചെറിയ മാറ്റങ്ങൾ ഉണ്ടാകാം.',
    },
    jyothi: {
      eyebrow: 'പഴമയുടെ വിശ്വാസം',
      title: 'അയ്യപ്പൻകാട്ടിലെ മകരജ്യോതി ദർശനം',
      sub: 'പഴമക്കാരിൽ നിന്ന് കൈമാറിവന്ന വിശ്വാസവും പാരമ്പര്യവും.',
      tag: 'മകരജ്യോതി',
      intro: 'മകരജ്യോതി ദർശനം പണ്ട് അയ്യപ്പൻകാട്ടിലും ഉണ്ടായിരുന്നുവെന്ന് പഴമക്കാർ പറഞ്ഞുകേട്ടിട്ടുണ്ട്.',
      beats: [
        {
          tag: 'വിശ്വാസം',
          t: 'ഉത്രം: ഭഗവാന്റെ ജന്മനക്ഷത്രം',
          d: 'മകരമാസത്തിലെ ഉത്രം നക്ഷത്രം അയ്യപ്പഭഗവാന്റെ ജന്മനക്ഷത്രമായി വിശ്വസിക്കപ്പെടുന്നു. ഈ പുണ്യദിനത്തിൽ ശബരിമലയിലെ ആശ്രമങ്ങളിൽ വസിച്ചിരുന്ന സന്യാസിമാരും ആദിവാസി ജനവിഭാഗങ്ങളും കർപ്പൂരം കത്തിച്ച് ആരതി ഉഴിഞ്ഞ് ശരണഘോഷങ്ങളോടെ ഭഗവാനെ ആരാധിച്ചിരുന്നു. ആ പ്രകാശം ദൂരെനിന്ന് ദർശിച്ച് ഭക്തർ തൊഴുതിരുന്നു; ഈ ആചാരം ഇപ്പോഴും തുടരുന്നുവെന്ന് നമുക്കറിയാം.',
        },
        {
          tag: 'ദർശനം',
          t: 'അയ്യപ്പൻമലയിലെ ജ്യോതി',
          d: 'പാലക്കാട് മകരവിളക്ക് ദിനത്തിൽ അയ്യപ്പൻമല എന്ന പേരിലുള്ള കാനന ക്ഷേത്രത്തിൽ തെളിഞ്ഞിരുന്ന കർപ്പൂരാരതിയുടെ ജ്യോതിദർശനമായിരുന്നു അയ്യപ്പൻകാട്ടിലെ ഭക്തർക്ക് ലഭിച്ചിരുന്നത്. ആ ദിവ്യപ്രകാശം ഭക്തിപൂർവം ദർശിച്ച് അവർ ശരണം വിളിച്ച് ഭഗവാനെ വണങ്ങിയിരുന്നുവെന്നാണ് പഴമക്കാർ പറയുന്നത്.',
        },
        {
          tag: 'പ്രത്യാശ',
          t: 'പുനർനിർമാണത്തിനു ശേഷം പുനരാരംഭിക്കണം',
          d: 'അയ്യപ്പൻകാട് ക്ഷേത്രത്തിന്റെ പുനർനിർമാണം പൂർത്തിയായാൽ, ഈ പുണ്യജ്യോതി ദർശനം പുനരാരംഭിച്ച് ഒരു മഹത്തായ ആത്മീയാഘോഷമാക്കി മാറ്റണമെന്നാണ് ഭക്തജനങ്ങളുടെ ആഗ്രഹം.',
        },
      ],
      quote: 'കലിയുഗത്തിലെ അധർമ്മത്തിന്റെ അന്ധകാരത്തിൽ കഴിയുന്ന മനുഷ്യരെ പ്രത്യാശയുടെയും ധർമ്മത്തിന്റെയും പ്രകാശത്തിലേക്ക് നയിക്കുന്ന അയ്യപ്പജ്യോതി ഓരോ ഹൃദയത്തിലും ഭക്തിയുടെയും നന്മയുടെയും വെളിച്ചം പകരട്ടെ.',
      saranam: 'സ്വാമിയേ ശരണം അയ്യപ്പാ!',
    },

    committee: {
      eyebrow: 'ഭാരവാഹികൾ',
      head: ['നം.', 'സ്ഥാനം', 'പേര്'],
      title: 'ക്ഷേത്ര സമിതി',
      sub: 'വിശ്വാസത്തോടെയും സമർപ്പണത്തോടെയും പുനരുദ്ധാരണത്തിന് നേതൃത്വം നൽകുന്ന ഭക്തർ.',
      groups: [
        { role: 'പ്രസിഡന്റ്', names: ['പ്രൊഫ. ശോഭ റാണി'] },
        { role: 'വൈസ് പ്രസിഡന്റ്', names: ['പ്രസന്ന വാസുദേവൻ'] },
        { role: 'സെക്രട്ടറിമാർ', names: ['ശ്രീമതി രാധ രാമനുണ്ണി', 'പ്രേമകുമാരി', 'മഹേശ്വരി മണി'] },
        { role: 'ട്രഷറർ', names: ['സരിത രാംദാസ്'] },
        { role: 'ജോയിന്റ് ട്രഷറർ', names: ['ഭാമിനി മുരളി'] },
      ],
    },

    contact: { title: 'ബന്ധപ്പെടുക', sub: 'അയ്യപ്പൻകാട് അയ്യപ്പ സേവാ സമിതി', name: 'പേര്', email: 'ഇമെയിൽ', msg: 'സന്ദേശം', send: 'സന്ദേശം അയയ്ക്കുക', address: 'അയ്യപ്പൻകാട്, കേരളം', thanks: 'നന്ദി! സ്വാമിയേ ശരണം.' },
    quote: 'ഭക്തിയോടെ ദർശനം… മനസ്സിൽ സമാധാനം…',
    home: {
      waysEyebrow: 'നിങ്ങളും പങ്കാളിയാകൂ',
      waysTitle: 'ക്ഷേത്രത്തെ പിന്തുണയ്ക്കാനുള്ള വഴികൾ',
      waysSub: 'ഓരോ ചെറിയ സമർപ്പണവും ക്ഷേത്രത്തെ വീണ്ടും പൂർണ്ണമാക്കുന്നു.',
      ways: [
        { t: 'പുനരുദ്ധാരണത്തിന് സഹായിക്കുക', d: 'പുണ്യക്ഷേത്രത്തിന്റെ പുനർനിർമ്മാണത്തിൽ പങ്കുചേരുക.' },
        { t: 'സേവനം ചെയ്യുക', d: 'നിങ്ങളുടെ സമയവും കഴിവും സമിതിക്കായി നൽകുക.' },
        { t: 'ഉത്സവങ്ങളിൽ പങ്കെടുക്കുക', d: 'വിളക്കും മണ്ഡലപൂജയും ഞങ്ങളോടൊപ്പം ആഘോഷിക്കുക.' },
        { t: 'ക്ഷേത്രം സന്ദർശിക്കുക', d: 'ദർശനത്തിനെത്തി ശാന്തി അനുഭവിക്കുക.' },
      ],
      go: 'കൂടുതൽ അറിയുക',
      pathEyebrow: 'പുനരുദ്ധാരണ യാത്ര',
      ctaTitle: 'പുണ്യസന്നിധി വീണ്ടെടുക്കാൻ ഞങ്ങളോടൊപ്പം ചേരൂ',
      ctaText: 'നിങ്ങളുടെ പ്രാർത്ഥനയും സാന്നിധ്യവും പിന്തുണയും വരും തലമുറകൾക്ക് വെളിച്ചമാകും.',
      ctaBtn1: 'പുനരുദ്ധാരണത്തിന് സഹായിക്കുക',
      ctaBtn2: 'സമിതിയെ ബന്ധപ്പെടുക',
    },
    footer: {
      quote1: 'ഭക്തിയോടെ ദർശനം…',
      quote2: 'മനസ്സിൽ സമാധാനം…',
      about: 'ധർമ്മശാസ്താവിന്റെ പുണ്യസന്നിധി; ഭക്തിയും പാരമ്പര്യവും സമാധാനവും ഒന്നിച്ച് ഒരു നല്ല നാളേയ്ക്കായി ഇവിടെ ചേരുന്നു.',
      links: 'പ്രധാന ലിങ്കുകൾ',
      info: 'ക്ഷേത്ര വിവരങ്ങൾ',
      contact: 'ബന്ധപ്പെടുക',
      follow: 'പിന്തുടരുക',
      stay1: 'ബന്ധം പുലർത്തുക',
      stay2: 'ക്ഷേത്രത്തോടൊപ്പം',
      stayText: 'ഉത്സവങ്ങൾ, പുനരുദ്ധാരണം, ക്ഷേത്ര പ്രവർത്തനങ്ങൾ എന്നിവയുടെ പുതിയ വിവരങ്ങൾ അറിയുക.',
      subscribe: 'അപ്ഡേറ്റുകൾക്കായി സബ്സ്ക്രൈബ് ചെയ്യുക',
      rights: 'എല്ലാ അവകാശങ്ങളും സംരക്ഷിതം.',
      devBy: 'Developed by',
      dev: 'Developed by Mpeoples',
      om: 'സ്വാമിയേ ശരണം അയ്യപ്പാ',
      addr1: 'അയ്യപ്പൻകാട് അയ്യപ്പൻ ക്ഷേത്രം,',
      addr2: 'പുതുശ്ശേരി, പാലക്കാട്.',
      addr3: '678623',

    },
  },

  ta: {
    brand: { name: 'ஐயப்பன்காடு தர்ம சாஸ்தா கோயில்', tag: 'பக்தி • பாரம்பரியம் • புனரமைப்பு' },
    nav: { home: 'முகப்பு', about: 'கோயில்', renovation: 'புனரமைப்பு', gallery: 'படங்கள்', festivals: 'திருவிழாக்கள்', contact: 'தொடர்புக்கு' },
    hero: {
      slides: [
        { eyebrow: 'சுவாமியே சரணம் ஐயப்பா', title: 'ஐயப்பன்காடு தர்ம சாஸ்தா கோயில்', text: 'பக்தர்களின் பக்தியால் மீண்டும் எழும் ஐயப்பனின் பழமையான சன்னதி.' },
        { eyebrow: 'கோயில் புனரமைப்பு', title: 'நூற்றாண்டு பழமையான கோயிலை மீட்டெடுப்போம்', text: 'ஐயப்பன்காடு கோயிலை மீண்டும் கட்ட பக்தர்கள் ஒன்றிணைகிறார்கள். இப்புண்ணிய பணியில் இணையுங்கள்.' },
        { eyebrow: 'பக்தியின் ஒளி', title: 'ஒவ்வொரு தீபத்திலும் ஒரு பிரார்த்தனை', text: 'தினசரி பூஜைகள், விளக்கு திருவிழாக்கள், கேரள கிராமத்தின் அமைதி.' },
      ],
      cta1: 'புனரமைப்புக்கு உதவுங்கள்', cta2: 'கோயிலை அறிக',
    },
    about: {
      eyebrow: 'கோயில் அறிமுகம்', title: 'தர்ம சாஸ்தாவின் காலத்தை வென்ற சன்னதி',
      p1: 'ஐயப்பன்காடு தர்ம சாஸ்தா கோயில் நூற்றாண்டுகளாக ஊர் மக்களின் நம்பிக்கை மையமாக உள்ளது. ஒரு காலத்தில் தினசரி வழிபாட்டால் செழித்த இப்புனித பூமி இன்று பக்தர்களின் கரங்களை எதிர்நோக்குகிறது.',
      p2: 'பெண்களின் தலைமையில் ஒரு குழு பக்தர்கள் தேவப்பிரஷ்னம் மற்றும் பாரம்பரியத்தின் வழிகாட்டுதலுடன் கோயிலை புனரமைக்கத் தொடங்கியுள்ளனர்.',
      deity: 'மூலவர்', deityV: 'ஸ்ரீ தர்ம சாஸ்தா (ஐயப்பன்)', location: 'இடம்', locationV: 'ஐயப்பன்காடு, கேரளா', est: 'தொன்மை', estV: 'நூற்றாண்டுகள் பழமை', more: 'மேலும் அறிக',
      historyTitle: 'கோயில் வரலாறு', history: 'ஐயப்பன்காடு என்ற பெயரில் அறியப்படும் இக்கோயில் தலைமுறைகளாகப் பாதுகாக்கப்பட்டது. முற்காலத்தில் 40 சென்ட் நிலம் கோயிலுக்காக ஒதுக்கப்பட்டதாக ஊர் மக்கள் நினைவுகூர்கின்றனர். இன்று கோயில் முற்றிலும் சிதிலமடைந்துள்ளது; அதை மீண்டும் உயிர்ப்பிக்க ஊர் ஒன்றிணைந்துள்ளது.',
    },
    abx: {
      journeyEyebrow: 'எங்கள் பயணம் இதுவரை',
      journeyTitle: 'சன்னதியை உயிர்ப்பித்த தருணங்கள்',
      journeySub: 'காட்டில் நடந்த முதல் பஜனை முதல் புதிய கோயிலின் அடிக்கல் நாட்டு விழா வரை.',
      journey: [
        'காட்டில் பாய் விரித்து முதன்முதலாக பஜனை பாடிய அம்மாக்கள்',
        'தேவப்பிரஷ்னம் நடந்த நாளில் யானைகள் கோயிலுக்கு வருகை',
        'விக்ரகம் சுத்திகரிக்கப்பட்ட பின் பூஜை',
        'அலங்காரம்',
        'கோயில் முற்றத்தில் முதன்முறையாக பாயசம் தயாரிப்பு',
        'கலவறை நிரப்புதல்',
        'கணபதி ஹோமத்திற்கு முன் விக்ரக அலங்காரம் (பகவதி சேவை)',
        'கணபதி ஹோமம்',
        'நாலகத்து இல்லத்து அம்மாவின் பூஜை',
        'நாராயணீயம் பாராயணம்',
        'பகவானுக்கு மாலை கட்டுதல்',
        'முதல் சப்தாகம்',
        'தற்போதைய நில உரிமையாளரின் வருகை',
        'தேவப்பிரஷ்னம்',
        'பூமி பூஜை',
        'ஸ்ரீ சதீஷ் மேனன் குற்றியடிக்கல் (முளை நடும்) சடங்கை நிறைவேற்றுகிறார்',
        'இல்லத்தரசிகள் மாதந்தோறும் நடத்தும் பஜனை',
        'ஒரு கோயிலை எழுப்ப அம்மாக்களின் பிரார்த்தனை',
        'சப்தாகம்: ஸ்ரீ கிருஷ்ணனும் ருக்மிணியும்',
        'ருக்மிணியை அழைத்து வருதல்',
      ],
      deityEyebrow: 'புனித திருவுருவம்',
      deityTitle: 'ஐயப்பன்காட்டின் விக்ரகம்',
      deitySub: 'விக்ரகத்தின் ஒவ்வொரு அம்சத்திற்கும் ஒரு பொருள் உண்டு.',
      tableHead: ['உறுப்பு', 'சிறப்பு', 'சாத்தியமான பொருள்'],
      form: [
        { p: 'தலை', f: 'மயில் தோகை விரிந்தது போன்ற ஜடைகள்', m: 'தவம், யோக சக்தி' },
        { p: 'சிரசு', f: 'இருபுறமும் விரியும் அலங்காரம்', m: 'ஜடாமகுடத்தின் தனி வடிவம்' },
        { p: 'தலைக்குப் பின்னால்', f: 'வட்ட வடிவ ஒளிவட்டம்', m: 'தெய்வீகம், ஒளி' },
        { p: 'கண்கள்', f: 'பாதி திறந்த நிலை', m: 'தியானமும் விழிப்பும்' },
        { p: 'அமர்வு', f: 'பத்மாசனம்', m: 'யோகமும் தன்னடக்கமும்' },
        { p: 'இடது கை', f: 'தொடையில் ஓய்வெடுக்கிறது', m: 'தியான நிலை' },
        { p: 'வலது கை', f: 'சுட்டுவிரலுக்கும் நடுவிரலுக்கும் இடையில் ஒரு பொருளைப் பிடித்துள்ளது', m: 'ஆயுதமோ சடங்குக் கருவியோ ஆகலாம்' },
        { p: 'வயிறு', f: 'குறுக்கே நாடா போன்ற பட்டை', m: 'உதரபந்தம்' },
        { p: 'கழுத்து', f: 'மாலைகளும் ருத்ராட்சமும்', m: 'தவம், ஆன்மீகம்' },
      ],
      chipsTitle: 'யோகீஸ்வரரின் சின்னங்கள்',
      chips: [
        ['பத்மாசனம்', 'தன்னடக்கம்'],
        ['ஜடாமகுடம்', 'தவ சக்தி'],
        ['ருத்ராட்சம்', 'வைராக்யம்'],
        ['பாசம்', 'பிணைக்கும் சக்தி'],
        ['அங்குசம்', 'வழிநடத்தும் சக்தி'],
        ['பிரபாமண்டலம்', 'தெய்வீகம்'],
      ],
      tattvaEyebrow: 'வழிகாட்டும் தத்துவம்',
      mantra: 'பாசேன பத்நாதி, அங்குசேன நயதி',
      mantraMeaning: 'பாசத்தால் அதர்மத்திலிருந்து மீட்டு, அங்குசத்தால் தர்ம வழியில் நடத்தும் தர்ம சாஸ்தா; தியானத்தில் ஆழ்ந்த யோகியும், தர்மத்தை நிலைநாட்டும் ஆட்சியாளரும், வனத்தின் காவலரும்.',
      roles: [
        { t: 'பாசம்', pts: ['அதர்மப் பிணைப்பிலிருந்து மீட்கிறது', 'தவறான செயல்களைக் கட்டுப்படுத்துகிறது', 'ஒழுக்கமும் நீதியும் அளிக்கிறது'] },
        { t: 'அங்குசம்', pts: ['தர்ம வழியில் நடத்துகிறது', 'மனதையும் புலன்களையும் கட்டுப்படுத்துகிறது', 'திசை உணர்வை அளிக்கிறது'] },
      ],
      shaktiEyebrow: 'தெய்வீக சக்திகள்',
      shaktiTitle: 'தர்ம சாஸ்தாவின் பன்னிரண்டு சக்திகள்',
      shaktiSub: 'அற்புதங்கள் மட்டுமல்ல; மனிதனை தர்மத்தில் நடத்தி, இயற்கையைக் காத்து, ஆன்மீகத்தில் உயர்த்தும் சக்திகள்.',
      shaktis: [
        { t: 'ஞான சக்தி', d: 'அறியாமையை நீக்கி விவேகத்தையும் சரியான முடிவெடுக்கும் திறனையும் அளிக்கிறது. குருவாகவும் ஆசிரியராகவும் அருள்கிறார்.' },
        { t: 'பாச சக்தி', d: 'தவறான வழியில் செல்பவர்களை தர்மத்துடன் இணைக்கிறது. தீய பழக்கங்களிலிருந்து விடுபட தன்னடக்கம் அளிக்கிறது.' },
        { t: 'அங்குச சக்தி', d: 'வழிதவறும் மனதையும் புலன்களையும் கட்டுப்படுத்தி சரியான திசையில் நடத்துகிறது.' },
        { t: 'அபய சக்தி', d: 'பயம், பாதுகாப்பின்மை, விரக்தி ஆகியவற்றை வெல்லும் துணிவையும் தன்னம்பிக்கையையும் அளிக்கிறது.' },
        { t: 'வீர சக்தி', d: 'அநீதிக்கு எதிராக நிற்கவும் பலவீனர்களைக் காக்கவும் துணிவையும் மன வலிமையையும் அளிக்கிறது.' },
        { t: 'யோக சக்தி', d: 'மனம், உடல், புலன்களின் சமநிலையையும் தியானத் திறனையும் வளர்க்கிறது.' },
        { t: 'அனுக்கிரக சக்தி', d: 'வாழ்க்கையின் சோதனைகளை எதிர்கொள்ள நம்பிக்கையையும் தன்னம்பிக்கையையும் அளிக்கிறது. நற்செயல்களுக்கு ஊக்கமாகிறது.' },
        { t: 'பிரகிருதி ரக்ஷா சக்தி', d: 'காடுகள், விலங்குகள், பறவைகள், நீர்நிலைகள், இயற்கை வளங்களைக் காக்கும் உணர்வை வளர்க்கிறது.' },
        { t: 'நியாய சக்தி', d: 'நீதி உணர்வு, நேர்மை, பொறுப்பு, அறவழி ஆட்சி உணர்வை வளர்க்கிறது.' },
        { t: 'தபஸ் சக்தி', d: 'தன்னடக்கம், பொறுமை, சகிப்புத்தன்மை, மன உறுதியை அதிகரிக்கிறது.' },
        { t: 'ரக்ஷா சக்தி', d: 'குடும்பத்திலும் சமூகத்திலும் அன்பு, பாதுகாப்பு உணர்வு, ஒத்துழைப்பைப் பேண ஊக்குவிக்கிறது.' },
        { t: 'மோட்ச சக்தி', d: 'அகங்காரம், ஆசை, அறியாமையிலிருந்து விடுவித்து ஆன்மீக உயர்வுக்கு வழிநடத்துகிறது.' },
      ],
      note: 'விக்ரகம் மற்றும் அதன் சின்னங்கள் பற்றிய விளக்கங்கள் பக்தி மரபைப் பின்பற்றுபவை; அறிஞர்கள் மற்றும் கோயில் மரபுகளிடையே மாறுபடலாம்.',
    },
    silas: {
      eyebrow: 'விழா',
      title: 'சிலாஸ்தாபனம்',
      subtitle: 'அடிக்கல் நாட்டு விழா',
      temple: 'ஐயப்பன்காடு ஐயப்பன் கோயில், புதுசேரி, பாலக்காடு',
      dateL: 'தேதி', date: 'வியாழக்கிழமை, 5 நவம்பர் 2026',
      timeL: 'நேரம்', time: 'காலை 7.10 முதல் 9.20 வரை',
      guestsT: 'முன்னிலை',
      guests: [
        { n: 'சுவாமி உதித் சைதன்யா', r: 'பாகவதகிராமம்' },
        { n: 'சுவாமி ஸ்வரூபானந்த சரஸ்வதி', r: 'சிவானந்தாசிரமம், பாலக்காடு' },
        { n: 'டாக்டர் ஷியாம் பிரசாத்', r: 'மேல்சாந்தி, ஆனிக்கோடு அன்புமூர்த்தி கோயில்' },
      ],
      orgL: 'ஏற்பாடு', org: 'சாந்தீபனி சாதனாலயம் சாரிட்டபிள் & வெல்ஃபேர் டிரஸ்ட்',
      phone: '9847960323',
      invite: 'அனைத்து பக்தர்களும் வருகை தந்து அருள் பெற அன்புடன் அழைக்கிறோம்.',
      cdT: 'நிகழ்வுக்கு மீதமுள்ள நேரம்', dLabel: 'நாள்', hLabel: 'மணி', mLabel: 'நிமிடம்',
      done: 'புனித நேரம் வந்துவிட்டது. சுவாமியே சரணம் ஐயப்பா!',
      cta2: 'புனரமைப்புக்கு உதவுங்கள்',
      jrTitle: 'புதிய சன்னதியை நோக்கிய படிகள்',
      jrSub: 'புனரமைப்புப் பயணத்தின் சமீபத்திய தருணங்கள்.',
      jrAll: 'முழு பயணத்தையும் காண்க',
    },
    quick: ['கோயில் வரலாறு', 'பூஜைகளும் சடங்குகளும்', 'திருவிழா விவரங்கள்', 'படங்கள்', 'வந்தடைய'],
    highlights: {
      title: 'கோயில் சிறப்புகள்', sub: 'ஐயப்பன்காட்டின் தெய்வீக அழகையும் ஆன்மீகத்தையும் அனுபவியுங்கள்.',
      items: [
        { t: 'புனித பாரம்பரியம்', d: 'நூற்றாண்டுகளின் வழிபாடும் மரபும்.' },
        { t: 'ஐயப்பன்', d: 'அனைத்து பக்தர்களுக்கும் தர்ம சாஸ்தாவின் அருள்.' },
        { t: 'தினசரி பூஜைகள்', d: 'நாள்தோறும் பூஜைகளும் வழிபாடுகளும்.' },
        { t: 'திருவிழாக்கள்', d: 'விளக்கு, மண்டல பூஜை மற்றும் பல.' },
        { t: 'அமைதியான சூழல்', d: 'கேரள கிராமத்தின் அமைதி.' },
        { t: 'சமூக சேவை', d: 'பக்தர்கள் வழிநடத்த, அனைவரும் ஆதரிக்கின்றனர்.' },
      ],
    },
    deities: {
      title: 'கோயில் தெய்வங்கள்',
      sub: 'ஐயப்பன்காட்டில் ஒவ்வொரு பக்தரையும் அருளும் மூலவரும் உபதெய்வங்களும்.',
      items: [
        { tag: 'மூலவர்', name: 'ஸ்ரீ ஐயப்பன்', d: 'தியானத்தில் ஆழ்ந்த யோகியும், தர்மத்தை நிலைநாட்டுபவரும், வனத்தின் காவலருமான தர்ம சாஸ்தா.' },
        { tag: 'தெய்வம் 1', name: 'தேவி', d: 'மூலஸ்தானத்தின் அருகில் எழுந்தருளி, அனைத்து பக்தர்களுக்கும் கருணை பொழியும் அன்னை.' },
        { tag: 'தெய்வம் 2', name: 'ஸ்ரீ கணபதி', d: 'தடைகளை நீக்குபவர்; ஒவ்வொரு பூஜையின் தொடக்கத்திலும் சுப காரியத்திலும் வணங்கப்படுபவர்.' },
      ],
    },
    gallery: {
      title: 'கோயில் படங்கள்', sub: 'கோயிலின் தெய்வீக தருணங்கள்.', all: 'அனைத்து படங்களையும் காண்க',
      eyebrow: 'புனித தருணங்கள்', photos: 'படங்கள்', hint: 'எந்தப் படத்தையும் தொட்டு பெரிதாகக் காணுங்கள்',
      mosaic: 'மொசைக்', grid: 'கிரிட்', view: 'படத்தைக் காண்க', close: 'மூடு', prev: 'முந்தையது', next: 'அடுத்தது',
      loadMore: 'மேலும் படங்களைக் காண்க',
      introEyebrow: 'எங்கள் படத்தொகுப்பு', introTitle: 'புனித சன்னதியின் காட்சிகள்',
      introText: 'ஐயப்பன்காட்டின் படங்களையும் வீடியோக்களையும் காணுங்கள்: தினசரி பூஜைகள், திருவிழா தீபங்கள், அமைதியான கிராமக் கோயில், கோயிலை மீட்டெடுக்கும் ஊரின் பக்தி.',
      videos: 'வீடியோக்கள்', heritage: 'பாரம்பரியம்', centuries: 'நூற்றாண்டுகள்',
      momentsEyebrow: 'நீங்கள் காணவிருப்பவை', momentsTitle: 'நாங்கள் போற்றும் தருணங்கள்',
      moments: [
        { t: 'தினசரி பூஜைகள்', d: 'சன்னதியை உயிர்ப்புடன் வைக்கும் காலை, மாலை வழிபாடுகள்.' },
        { t: 'திருவிழா தீபங்கள்', d: 'கோயில் வளாகத்தில் ஒளிரும் விளக்கு வரிசைகள்.' },
        { t: 'கிராமக் கோயில்', d: 'கேரள கிராமக் கோயிலின் அமைதியான அழகு.' },
        { t: 'புனரமைப்பு சேவை', d: 'சன்னதியை மீண்டும் கட்ட ஒன்றிணையும் பக்தர்கள்.' },
      ],
      videosEyebrow: 'காணுங்கள்', videosTitle: 'கோயில் வீடியோக்கள்', videosSub: 'வீடியோவைத் தொட்டு பெரிதாகக் காணுங்கள்.',
      videoTitles: ['கோயில் தரிசனம்', 'திருவிழா விளக்கு', 'புனரமைப்பு சேவை', 'கிராமக் கோயில்'],
      play: 'வீடியோவை இயக்கு',
      ctaTitle: 'எங்கள் கதையின் பகுதியாகுங்கள்', ctaText: 'கோயிலுக்கு வாருங்கள், திருவிழாக்களில் இணையுங்கள், சன்னதியை மீண்டும் உயிர்ப்பிக்க உதவுங்கள்.',
      ctaBtn1: 'புனரமைப்புக்கு உதவுங்கள்', ctaBtn2: 'சமிதியைத் தொடர்பு கொள்ளுங்கள்',
    },
    festivals: {
      title: 'திருவிழாக்கள்', sub: 'தெய்வீகத்தை கொண்டாட இணையுங்கள்.', all: 'அனைத்து திருவிழாக்களும்', learn: 'மேலும் அறிக',
      items: [
        { m: 'ஜன – பிப்', t: 'மகர விளக்கு', d: 'சிறப்பு தரிசனம், தீபங்கள், கலை நிகழ்ச்சிகள்.' },
        { m: 'நவ – டிச', t: 'மண்டல பூஜை', d: 'நாற்பத்தொரு நாள் விரதமும் மகா பூஜையும்.' },
        { m: 'கார்த்திகை', t: 'கார்த்திகை விளக்கு', d: 'கோயில் வளாகத்தில் தீபம் ஏற்றுதல்.' },
        { m: 'டிச – ஜன', t: 'சபரிமலை யாத்திரை', d: 'இருமுடியுடன் புனித யாத்திரை தொடக்கம்.' },
      ],
    },
    festPage: {
      vzEyebrow: 'சிறப்பு வழிபாடுகள்',
      vzTitle: 'சிறப்பு வழிபாடுகள் (காணிக்கைகள்)',
      vzSub: 'கோயிலில் பக்தர்கள் செலுத்தக்கூடிய சிறப்பு வழிபாடுகள்.',
      vzItems: [
        {
          t: 'நெய் விளக்கு', ml: 'നെയ്‌വിളക്ക്', tag: 'காணிக்கை',
          d: 'பக்தி, பிரார்த்தனையின் ஒளியாக பகவானின் முன் தூய நெய்யால் விளக்கு ஏற்றுதல்.',
        },
        {
          t: 'எழுதிரி கத்திக்கல்', ml: 'എഴുതിരി കത്തിക്കൽ', tag: 'ஒவ்வொரு சனிக்கிழமையும்',
          d: 'ஒவ்வொரு சனிக்கிழமையும் தெய்வத்தின் முன் பல திரி விளக்கு ஏற்றும் வழிபாடு.',
        },
        {
          t: 'நீராஞ்ஜனம்', ml: 'നീരാഞ്ജനം', tag: 'பூஜை',
          d: 'தடைகள் நீங்கவும் ஐயப்பனின் அருள் பெறவும் பிரார்த்தனையுடன் செய்யும் பாரம்பரிய தீப வழிபாடு.',
        },
      ],
      vzNote: 'வழிபாடுகளை முன்பதிவு செய்யவும் நேரங்களை உறுதிசெய்யவும் சமிதியைத் தொடர்பு கொள்ளுங்கள்.',
      eyebrow: 'புனித வழிபாடுகள்',
      intro: 'ஆண்டு முழுவதும் தீபங்களாலும் விரதத்தாலும் பிரார்த்தனையாலும் கோயில் உயிர்பெறுகிறது. ஒவ்வொரு திருவிழாவும் பக்தர்கள் ஒன்றுகூடி தர்ம சாஸ்தாவின் அருளைப் பெறும் வாய்ப்பாகும்.',
      stats: [
        { v: '4', l: 'முக்கிய திருவிழாக்கள்' },
        { v: '41', l: 'நாள் மண்டல விரதம்' },
        { v: 'நவ – பிப்', l: 'திருவிழா காலம்' },
        { v: 'அனைவருக்கும்', l: 'பக்தர்களுக்கு வரவேற்பு' },
      ],
      detailsEyebrow: 'திருவிழா விவரங்கள்',
      detailsTitle: 'ஐயப்பன்காட்டின் வழிபாடுகள்',
      highlightsT: 'வழக்கமான வழிபாடுகள்',
      items: [
        {
          long: 'மகர சங்கராந்தியை ஒட்டி மகர விளக்கு கொண்டாடப்படுகிறது. பருவ மாற்றத்தின் புனித நேரத்தில் பக்தர்கள் ஒன்றுகூடுகின்றனர். தீப வரிசைகளால் சன்னதி ஒளிர்கிறது; சிறப்பு தரிசனமும் ஊர் மக்களுக்கான கலை நிகழ்ச்சிகளும் இடம்பெறும்.',
          points: ['சிறப்பு தரிசனம்', 'மாலையில் தீபம் ஏற்றுதல்', 'அனைத்து வயதினருக்கும் கலை நிகழ்ச்சிகள்'],
        },
        {
          long: 'நாற்பத்தொரு நாள் கடுமையான விரதத்தின் நிறைவாக மண்டல பூஜை நடைபெறுகிறது. பக்தர்கள் எளிய வாழ்க்கை மேற்கொண்டு மாலை அணிந்து தினமும் கோயிலுக்கு வருகின்றனர்; மண்டல காலத்தின் இறுதியில் மகா பூஜையுடன் நிறைவடைகிறது.',
          points: ['நாற்பத்தொரு நாள் விரதம்', 'தினசரி பிரார்த்தனையும் பஜனையும்', 'இறுதி நாளில் மகா பூஜை'],
        },
        {
          long: 'கார்த்திகை விளக்கின்போது கோயில் வளாகம் முழுவதும் தீபங்கள் ஏற்றப்படுகின்றன. குடும்பங்களும் அண்டை வீட்டாரும் ஒன்றுகூட, கோயில் வளாகம் பக்தியின் ஒளியால் நிறைகிறது.',
          points: ['வளாகம் முழுவதும் தீபங்கள்', 'மாலை பிரார்த்தனை', 'ஊர் முழுவதும் பங்கேற்பு'],
        },
        {
          long: 'பக்தர்கள் சுமக்கும் புனித மூட்டையான இருமுடியுடன் சபரிமலை யாத்திரை தொடங்குகிறது. பிரார்த்தனையுடனும் விரதத்துடனும் தயாராகி ஐயப்பனின் அருளுடன் பக்தர்கள் ஒன்றாகப் புறப்படுகின்றனர்.',
          points: ['இருமுடி தயாரிப்பு', 'புறப்படும் முன் பிரார்த்தனை', 'பக்தர்கள் ஒன்றாகப் புறப்படுதல்'],
        },
      ],
      calEyebrow: 'முன்கூட்டியே அறிய',
      calTitle: 'திருவிழா காலம் ஒரு பார்வையில்',
      calSub: 'குறிக்கப்பட்ட மாதங்களில் ஒவ்வொரு திருவிழாவும் கொண்டாடப்படுகிறது.',
      months: ['ஜன', 'பிப்', 'மார்', 'ஏப்', 'மே', 'ஜூன்', 'ஜூலை', 'ஆக', 'செப்', 'அக்', 'நவ', 'டிச'],
      guideEyebrow: 'பக்தர்களுக்கு',
      guideTitle: 'திருவிழாக்களை அனுசரிக்கும் முறை',
      guide: [
        { t: 'விரதம்', d: 'அனுசரிப்பு காலத்தில் எளிய, ஒழுக்கமான வாழ்க்கை, பிரார்த்தனை, தூய மனதைப் பின்பற்றுங்கள்.' },
        { t: 'உடை', d: 'கோயிலுக்கு வரும்போது பாரம்பரியமான, எளிய உடை அணியுங்கள்.' },
        { t: 'காணிக்கை', d: 'பூக்கள், தீபத்திற்கான எண்ணெய் அல்லது பக்தியுடன் செய்யும் எந்தக் காணிக்கையையும் கொண்டு வரலாம்.' },
        { t: 'ஒன்றாக', d: 'சமூகத்துடன் இணைந்து சேவையில் பங்கேற்று, கோயில் வளாகத்தைத் தூய்மையாகவும் அமைதியாகவும் வைத்திருங்கள்.' },
      ],
      note: 'தேதிகள் பாரம்பரிய கோயில் நாட்காட்டியைப் பின்பற்றுகின்றன; ஆண்டுதோறும் மாறலாம். உறுதிசெய்யப்பட்ட தேதிகளுக்கு சமிதியைத் தொடர்பு கொள்ளவும்.',
      ctaTitle: 'எங்களுடன் கொண்டாடுங்கள்',
      ctaText: 'திருவிழாக்களில் இணையுங்கள், சேவை செய்யுங்கள், சன்னதியை மீண்டும் உயிர்ப்பிக்க உதவுங்கள்.',
      ctaBtn1: 'சமிதியைத் தொடர்பு கொள்ளுங்கள்',
      ctaBtn2: 'புனரமைப்புக்கு உதவுங்கள்',
    },
    visit: {
      title: 'தரிசனத்திற்கு', sub: 'தெய்வீக அருளுக்கான பயணம் இங்கே தொடங்குகிறது.', timingsT: 'தரிசன நேரம்', timings: 'தற்போதைய நேரத்திற்கு குழுவை தொடர்பு கொள்ளவும்', locT: 'இடம்', loc: 'ஐயப்பன்காடு, கேரளா', guideT: 'பார்வையாளர் வழிகாட்டி', guide: 'பாரம்பரிய உடை • கோயில் ஒழுக்கத்தைப் பின்பற்றவும்', directions: 'வழி காண்க',
    },
    reno: {
      title: 'கோயில் புனரமைப்பு', sub: 'அனைத்து பக்தர்களுக்கும் உளமார்ந்த வேண்டுகோள்', greeting: 'அன்பான பக்தர்களே,',
      paras: [
        'நூற்றாண்டுகளாக ஐயப்பன்காடு என்ற பெயரில் அறியப்படும் ஐயப்பன்காடு தர்ம சாஸ்தா கோயில் இன்று முற்றிலும் சிதிலமடைந்த நிலையில் உள்ளது. இது ஐயப்ப பக்தர்களுக்குப் பெரும் வருத்தத்தை அளிக்கிறது.',
        'பெண்களின் தலைமையில் ஒரு குழு பக்தர்கள் கோயிலைப் புனரமைக்கும் முயற்சிகளைத் தொடங்கியுள்ளனர். ஊர் மக்கள் தரும் தகவலின்படி, முற்காலத்தில் 40 சென்ட் நிலம் கோயிலுக்காக ஒதுக்கப்பட்டிருந்தது. முந்தைய உரிமையாளர்கள் இன்று உயிருடன் இல்லாவிட்டாலும், இந்நிலம் கோயில் சொத்தாகப் பராமரிக்கப்பட்டது என்பதை ஊர் மக்கள் அறிவர்.',
        'கோயில் மறுகட்டுமானத்தைத் தொடங்கும் முன் நிலம் தொடர்பான விஷயங்களைத் தீர்க்க வேண்டும் என்று தேவப்பிரஷ்னத்தில் கூறப்பட்டது. அதன்படி பக்தர்கள் தேவையான நடவடிக்கைகளை மேற்கொண்டு வருகின்றனர்.',
        'கோயில் சொத்தாக அடையாளம் காணப்பட்ட நிலம் தற்போது பாதுகாக்கப்படுகிறது. நிலத்தின் மீது உண்மையான உரிமை உள்ளவர்கள் உரிய ஆவணங்களுடன் முன்வருமாறு கேட்டுக்கொள்கிறோம்.',
        'பரஸ்பர புரிதல், ஒத்துழைப்பு மற்றும் நட்புடன் கூடிய பேச்சுவார்த்தைகள் மூலம் அனைத்தையும் தீர்க்க முடியும் என்று உளமார நம்புகிறோம். இப்பிரச்சினைகளை சுமுகமாகத் தீர்க்க அனைவரும் ஒத்துழைக்குமாறு பணிவுடன் வேண்டுகிறோம்.',
        'அருகிலுள்ளவர்கள், ஊர் மக்கள் மற்றும் அனைத்து பக்தர்களும் இவ்வறிவிப்பை ஒத்துழைப்புக்கான உளமார்ந்த வேண்டுகோளாகக் கருதி, கோயில் புனரமைப்புப் பணிகளுக்கு ஆதரவு அளிக்குமாறு பணிவுடன் கேட்டுக்கொள்கிறோம்.',
      ],
      saranam: 'சுவாமியே சரணம் ஐயப்பா!!', org: 'ஐயப்பன்காடு ஐயப்ப சேவா சமிதி', behalf: 'உறுப்பினர்கள் சார்பாக',
      stepsTitle: 'எங்கள் அடுத்த படிகள்',
      steps: ['தேவப்பிரஷ்ன வழிகாட்டுதல்', 'கோயில் நிலப் பாதுகாப்பு', 'உரிமைகளை நட்புடன் தீர்த்தல்', 'கோயில் மறுகட்டுமானம்'],
      cta: 'சமிதியைத் தொடர்பு கொள்ளுங்கள்',
    },
    renoPage: {
      eyebrow: 'உளமார்ந்த வேண்டுகோள்',
      facts: [
        { v: 'நூற்றாண்டுகள்', l: 'கோயிலின் பாரம்பரியம்' },
        { v: '40 சென்ட்', l: 'கோயிலுக்காக ஒதுக்கப்பட்ட நிலம்' },
        { v: 'தேவப்பிரஷ்னம்', l: 'ஒவ்வொரு படியிலும் வழிகாட்டி' },
        { v: 'பெண்கள் தலைமை', l: 'பக்தர் குழுவின் தலைமை' },
      ],
      noticeTag: 'முக்கிய அறிவிப்பு',
      lampEyebrow: 'பிரார்த்தனை செய்யுங்கள்',
      lampTitle: 'கோயிலுக்காக ஒரு தீபம் ஏற்றுங்கள்',
      lampSub: 'தீபத்தைத் தொட்டு உங்கள் பிரார்த்தனையுடன் ஏற்றுங்கள். ஒவ்வொரு சுடரும் சன்னதி மீண்டும் எழ வேண்டும் என்ற வேண்டுதல்.',
      lampsLit: 'தீபங்கள் ஏற்றப்பட்டன',
      lampAll: 'அனைத்து தீபங்களையும் ஏற்றுங்கள்',
      lampReset: 'மீண்டும் தொடங்கு',
      lampBless: 'சுவாமியே சரணம்! உங்கள் பிரார்த்தனை நிறைவேறட்டும்.',
      ctaTitle: 'புனரமைப்பில் பங்கேற்கவும்',
      ctaText: 'உங்கள் பிரார்த்தனை, வருகை, ஆதரவுடன் முன்வாருங்கள்.',
      ctaBtn2: 'கோயிலை அறிக',
      structEyebrow: 'புதிய சன்னதி',
      structTitle: 'கோயில் கட்டமைப்பு',
      structSub: 'கட்டுமானம் நிறைவடைந்ததும் பாரம்பரிய கேரள பாணியில் புனரமைக்கப்பட்ட சன்னதி இவ்வாறு காட்சியளிக்கும்.',
      renderTag: 'கட்டுமானத்திற்குப் பின்',
      renderCap: 'நிறைவடைந்த சன்னதிகளின் கற்பனைத் தோற்றம்',
      blueprintTag: 'அசல் வரைபடம்',
      blueprintCap: 'கட்டுமானத்திற்காகக் கையால் வரையப்பட்ட வரைபடம்',
      zoomHint: 'படத்தைத் தொட்டு பெரிதாகக் காணுங்கள்',
      closeLabel: 'மூடு',
      structFeaturesT: 'வடிவமைப்பின் சிறப்புகள்',
      structFeatures: [
        { t: 'இரட்டை சன்னதிகள்', d: 'அருகருகே இரண்டு ஸ்ரீகோயில்கள்: ஒன்று தர்ம சாஸ்தாவுக்கும் மற்றொன்று தேவிக்கும்.' },
        { t: 'ஓடு வேய்ந்த கூரை', d: 'சிவப்பு களிமண் ஓடுகள் வேய்ந்த, அழகாக மேல்நோக்கி வளைந்த முனைகளைக் கொண்ட சரிவுக் கூரை.' },
        { t: 'மரத் தூண்கள்', d: 'கடைந்து மெருகூட்டிய மரத் தூண்களும் செதுக்கப்பட்ட மரச் சுவர்களும்.' },
        { t: 'தங்கக் கலசம்', d: 'ஒவ்வொரு கூரையின் உச்சியிலும் கேரளக் கோயில்களின் புனித அடையாளமான தங்கக் கலசம்.' },
        { t: 'கருங்கல் அதிஷ்டானம்', d: 'படிகளாக அமைந்த கருங்கல் அதிஷ்டானம் ஒவ்வொரு சன்னதியையும் தரையிலிருந்து உயர்த்துகிறது.' },
        { t: 'திறந்த முற்றம்', d: 'தென்னை மரங்களும் பசுமையும் நிழல் தரும் அமைதியான கோயில் முற்றம்.' },
      ],
      structNote: 'படங்கள் குறிப்புக்காக மட்டுமே. தேவப்பிரஷ்னம் மற்றும் தந்திரியின் வழிகாட்டுதலின்படி இறுதி கட்டுமானத்தில் சிறிய மாற்றங்கள் இருக்கலாம்.',
    },
    jyothi: {
      eyebrow: 'முன்னோர்களின் நம்பிக்கை',
      title: 'ஐயப்பன்காட்டில் மகரஜோதி தரிசனம்',
      sub: 'ஊரின் முதியவர்கள் வழியாகத் தொடர்ந்து வந்த நம்பிக்கையும் பாரம்பரியமும்.',
      tag: 'மகரஜோதி',
      intro: 'மகரஜோதி தரிசனம் முற்காலத்தில் ஐயப்பன்காட்டிலும் இருந்ததாக முதியவர்கள் நினைவுகூர்கின்றனர்.',
      beats: [
        {
          tag: 'நம்பிக்கை',
          t: 'உத்திரம்: பகவானின் ஜென்ம நட்சத்திரம்',
          d: 'மகர மாதத்தின் உத்திர நட்சத்திரம் ஐயப்பனின் ஜென்ம நட்சத்திரமாக நம்பப்படுகிறது. இந்தப் புனித நாளில் சபரிமலை ஆசிரமங்களில் வாழ்ந்த துறவிகளும் பழங்குடி மக்களும் கற்பூரம் ஏற்றி ஆரத்தி எடுத்து சரண கோஷத்துடன் பகவானை வழிபட்டனர்; அந்த ஒளியை தொலைவிலிருந்து தரிசித்து பக்தர்கள் வணங்கினர். இந்த வழக்கம் இன்றும் தொடர்கிறது என்பதை நாம் அறிவோம்.',
        },
        {
          tag: 'தரிசனம்',
          t: 'ஐயப்பன்மலையின் ஒளி',
          d: 'மகரவிளக்கு நாளில் பாலக்காட்டில் ஐயப்பன்மலை என்ற பெயருடைய வனக் கோயிலில் ஏற்றப்படும் கற்பூர ஆரத்தியின் ஜோதியை ஐயப்பன்காட்டு பக்தர்கள் தரிசித்து வந்தனர். அந்தத் தெய்வீக ஒளியைப் பக்தியுடன் கண்டு சரணம் முழங்கி பகவானை வணங்கினர் என்று முதியவர்கள் கூறுகின்றனர்.',
        },
        {
          tag: 'நம்பிக்கை ஒளி',
          t: 'மறுகட்டுமானத்திற்குப் பின் மீண்டும் தொடங்க வேண்டும்',
          d: 'ஐயப்பன்காடு கோயிலின் மறுகட்டுமானம் நிறைவடைந்ததும் இந்தப் புனித ஜோதி தரிசனத்தை மீண்டும் தொடங்கி, ஒரு மாபெரும் ஆன்மீகக் கொண்டாட்டமாக மாற்ற வேண்டும் என்பதே பக்தர்களின் விருப்பம்.',
        },
      ],
      quote: 'கலியுகத்தின் அதர்ம இருளில் வாழும் மனிதர்களை நம்பிக்கை மற்றும் தர்மத்தின் ஒளியை நோக்கி வழிநடத்தும் ஐயப்ப ஜோதி, ஒவ்வொரு இதயத்திலும் பக்தியின் மற்றும் நன்மையின் ஒளியைப் பரப்பட்டும்.',
      saranam: 'சுவாமியே சரணம் ஐயப்பா!',
    },

    committee: {
      eyebrow: 'நிர்வாகிகள்',
      head: ['எண்', 'பதவி', 'பெயர்'],
      title: 'கோயில் சமிதி',
      sub: 'நம்பிக்கையுடனும் அர்ப்பணிப்புடனும் புனரமைப்புக்குத் தலைமை தாங்கும் பக்தர்கள்.',
      groups: [
        { role: 'தலைவர்', names: ['பேராசிரியர் ஷோபா ராணி'] },
        { role: 'துணைத் தலைவர்', names: ['பிரசன்னா வாசுதேவன்'] },
        { role: 'செயலாளர்கள்', names: ['ஸ்ரீமதி ராதா ராமனுண்ணி', 'பிரேமகுமாரி', 'மகேஸ்வரி மணி'] },
        { role: 'பொருளாளர்', names: ['சரிதா ராம்தாஸ்'] },
        { role: 'இணைப் பொருளாளர்', names: ['பாமினி முரளி'] },
      ],
    },
    contact: { title: 'தொடர்புக்கு', sub: 'ஐயப்பன்காடு ஐயப்ப சேவா சமிதி', name: 'உங்கள் பெயர்', email: 'மின்னஞ்சல்', msg: 'உங்கள் செய்தி', send: 'செய்தி அனுப்பு', address: 'ஐயப்பன்காடு, கேரளா', thanks: 'நன்றி! சுவாமியே சரணம்.' },
    quote: 'பக்தியுடன் தரிசனம்… மனதில் அமைதி…',
    home: {
      waysEyebrow: 'நீங்களும் பங்கேற்கலாம்',
      waysTitle: 'கோயிலை ஆதரிக்கும் வழிகள்',
      waysSub: 'ஒவ்வொரு சிறு காணிக்கையும் சன்னதியை மீண்டும் முழுமையாக்குகிறது.',
      ways: [
        { t: 'புனரமைப்புக்கு உதவுங்கள்', d: 'புனித சன்னதியை மீண்டும் கட்ட பங்களியுங்கள்.' },
        { t: 'சேவை செய்யுங்கள்', d: 'உங்கள் நேரத்தையும் திறனையும் சமிதிக்கு வழங்குங்கள்.' },
        { t: 'திருவிழாவில் இணையுங்கள்', d: 'விளக்கு, மண்டல பூஜையை எங்களுடன் கொண்டாடுங்கள்.' },
        { t: 'கோயிலுக்கு வாருங்கள்', d: 'தரிசனத்திற்கு வந்து அமைதியை உணருங்கள்.' },
      ],
      go: 'மேலும் அறிக',
      pathEyebrow: 'புனரமைப்புப் பயணம்',
      ctaTitle: 'புனித சன்னதியை மீட்டெடுக்க எங்களுடன் இணையுங்கள்',
      ctaText: 'உங்கள் பிரார்த்தனை, வருகை, ஆதரவு வரும் தலைமுறைகளுக்கு ஒளியாகும்.',
      ctaBtn1: 'புனரமைப்புக்கு உதவுங்கள்',
      ctaBtn2: 'சமிதியைத் தொடர்பு கொள்ளுங்கள்',
    },
    footer: {
      quote1: 'பக்தியுடன் தரிசனம்…',
      quote2: 'மனதில் அமைதி…',
      about: 'தர்ம சாஸ்தாவின் புனித சன்னதி; இங்கு பக்தி, பாரம்பரியம், அமைதி ஒன்றிணைந்து சிறந்த நாளைக்கு வழிவகுக்கின்றன.',
      links: 'இணைப்புகள்',
      info: 'கோயில் தகவல்',
      contact: 'தொடர்பு',
      follow: 'பின்தொடர',
      stay1: 'தொடர்பில் இருங்கள்',
      stay2: 'எங்கள் கோயிலுடன்',
      stayText: 'திருவிழாக்கள், புனரமைப்பு மற்றும் கோயில் நிகழ்வுகளின் புதிய தகவல்களைப் பெறுங்கள்.',
      subscribe: 'புதுப்பிப்புகளுக்கு சந்தா',
      rights: 'அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.',
      devBy: 'Developed by',
      dev: 'Developed by Mpeoples',
      om: 'சுவாமியே சரணம் ஐயப்பா',
      addr1: 'ஐயப்பன்காடு ஐயப்பன் கோயில்,',
      addr2: 'புதுசேரி, பாலக்காடு.',
      addr3: '678623',
    },
  },
};
export default translations;


